function initArchive() {
    let gridItems = document.querySelectorAll<HTMLElement>(".archive__grid__item");

    if (gridItems.length > 0) {
        for (let i = 0; i < gridItems.length; i++) {
            const gridItem = gridItems[i];
            let ref = i % (Object.keys(archiveCardColours).length);

            let bgCol = `var(--colour-${archiveCardColours[ref].background})`;
            let textCol = `var(--colour-${archiveCardColours[ref].text})`;

            gridItem.style.backgroundColor = bgCol;
            gridItem.style.color = textCol;

            gridItem.querySelector<HTMLElement>(".border-hover__border").style.borderColor = textCol;
            gridItem.querySelector<HTMLElement>(".archive__grid__item__text__arrow").children[0].style.fill = textCol;

            if (gridItem.querySelector(".archive__grid__item__img__label")) {
                gridItem.querySelector<HTMLElement>(".archive__grid__item__img__label").style.color = bgCol;
                gridItem.querySelector<HTMLElement>(".archive__grid__item__img__label").style.backgroundColor = textCol;
            }

            let coLabel = gridItem.querySelectorAll(".archive__grid__item__text__label__item");
            if (coLabel.length > 0) {
                coLabel.forEach(label => {
                    let labelPaths = label.querySelectorAll("path");
                    labelPaths.forEach(path => {
                        path.style.fill = textCol;
                    });
                });
            }
        }
    }

    let sideFilters = document.querySelectorAll<HTMLElement>(".side-filter__head")
    sideFilters.forEach(sideFilter => {
        sideFilter.addEventListener("click", function () {
            sideFilter.classList.toggle("side-filter__head--active")
        })
    });

    let expandAll = document.querySelector<HTMLElement>(".accordion__expand-all")
    let accordions = document.querySelectorAll<HTMLElement>(".accordion__item__head")

    if (accordions.length > 0) {
        const hash = window.location.hash

        if (hash) {
            if (hash.includes("msdynmkt_trackingcontext")) return
            let hashElement = document.querySelector<HTMLElement>(hash)

            if (hashElement) {
                if (hashElement.classList.contains("accordion__item__head")) {
                    const upperElement = hashElement.parentElement.parentElement.parentElement

                    if (upperElement.classList.contains("accordion__item")) {
                        upperElement.querySelectorAll<HTMLElement>(".accordion__item__head")[0].classList.add("accordion__item__head--active")
                    }

                    hashElement.classList.add("accordion__item__head--active")

                    setTimeout(() => {
                        scroller.scrollTo(hashElement, true, "center center");
                    }, 1000);
                }
            }
        }
    }

    initAccordionClicks(accordions, expandAll)

    if (expandAll) {
        expandAll.innerText = "Expand all"

        expandAll.addEventListener("click", function () {
            if (expandAll.innerText === "Expand all") {
                accordions.forEach(accordion => {
                    accordion.classList.add("accordion__item__head--active")
                });
                expandAll.innerText = "Close all"

            } else {
                accordions.forEach(accordion => {
                    accordion.classList.remove("accordion__item__head--active")
                });
                expandAll.innerText = "Expand all"
            }

            setTimeout(() => { ScrollTrigger.refresh() }, 500);
        })
    }

    let bannerBtns = document.querySelectorAll<HTMLElement>(".archive__banner__head")
    bannerBtns.forEach(bannerBtn => {
        bannerBtn.addEventListener("click", function () {
            bannerBtn.classList.toggle("archive__banner__head--active")
        })
    });
}

function initAccordionClicks(accordions, expandAll) {
    accordions.forEach(accordion => {
        accordion.addEventListener("click", function () {
            accordion.classList.toggle("accordion__item__head--active")

            let accordionChildren = accordion.nextElementSibling.querySelectorAll(".accordion__item__head--active")
            accordionChildren.forEach(child => {
                child.classList.remove("accordion__item__head--active")
            });

            if (expandAll) {
                if (expandAll.innerText === "Expand all") {
                    expandAll.innerText = "Close all"

                } else {
                    if (!document.querySelector(".accordion__item__head--active")) {
                        expandAll.innerText = "Expand all"
                    }
                }
            }
        })
    });
}
const fpActiveClass = "floorplan__cont__item--active";

function initFPSlider() {
    let floorplans = document.querySelectorAll(".floorplan");

    floorplans.forEach(floorplan => {
        let slides = floorplan.querySelectorAll(".floorplan__cont__item");
        slides[0].classList.add(fpActiveClass);

        // init floorplan overview interactions
        slides.forEach(slide => {
            // Polys and TRs
            let refs = slide.querySelectorAll(".floorplan__cont__item__main__plan__img svg polygon, .floorplan__cont__item__main__detail__table tr");

            refs.forEach(ref => {
                if (ref.dataset.id) {
                    let corrEl = slide.querySelector(`${(ref.tagName === "polygon" ? "tr" : "svg polygon")}[data-id="${ref.dataset.id}"]`)

                    if (corrEl) {
                        ref.addEventListener("mouseenter", () => corrEl.classList.add("hover"));
                        ref.addEventListener("mouseleave", () => corrEl.classList.remove("hover"));
                    }

                    let slideTo = floorplan.querySelector(`.floorplan__cont__item[data-id="${ref.dataset.id}"]`);
                    if (slideTo) {
                        ref.addEventListener("click", function () {
                            let toIndex = Array.prototype.indexOf.call(slides, slideTo);
                            fpSwitchSlide(toIndex, slides, floorplan);
                        });
                    }

                }
            });

            let switchView = slide.querySelector(".floorplan__cont__item__main__detail__switch")
            if (switchView) {
                switchView.addEventListener("click", function () {
                    switchView.classList.toggle("floorplan__cont__item__main__detail__switch--active")
                    slide.querySelector(".floorplan__cont__item__main__plan__img--overlay").classList.toggle("floorplan__cont__item__main__plan__img--overlay--active")
                })
            }
        });

        // init arrows
        let leftArrow = floorplan.querySelector(".floorplan__arrows__item--left");
        let rightArrow = floorplan.querySelector(".floorplan__arrows__item--right");

        if (leftArrow && rightArrow) {
            leftArrow.classList.add("floorplan__arrows__item--disabled");

            leftArrow.addEventListener("click", function () {
                let currIndex = Array.prototype.indexOf.call(slides, floorplan.getElementsByClassName(fpActiveClass)[0]);
                fpSwitchSlide(currIndex - 1, slides, floorplan);
            });

            rightArrow.addEventListener("click", function () {
                let currIndex = Array.prototype.indexOf.call(slides, floorplan.getElementsByClassName(fpActiveClass)[0]);
                fpSwitchSlide(currIndex + 1, slides, floorplan);
            });
        }

        // init dots
        let dots = document.querySelectorAll(".floorplan__dots__item");
        if (dots.length > 0) {
            dots[0].classList.add("floorplan__dots__item--active");
            for (let i = 0; i < dots.length; i++) {
                dots[i].addEventListener("click", function () {
                    fpSwitchSlide(i, slides, floorplan);
                });
            }
        }
    });
}

function fpSwitchSlide(i: number, slides: NodeListOf<HTMLElement>, floorplan: Element) {
    // switch active slide
    floorplan.getElementsByClassName(fpActiveClass)[0].classList.remove(fpActiveClass);
    slides[i].classList.add(fpActiveClass);

    // switch active dots
    let dots = floorplan.querySelectorAll(".floorplan__dots__item")
    if (dots.length > 0) {
        floorplan.querySelector(".floorplan__dots__item--active").classList.remove("floorplan__dots__item--active");
        dots[i].classList.add("floorplan__dots__item--active");
    }

    // switch arrow states
    let leftArrow = floorplan.querySelector(".floorplan__arrows__item--left");
    let rightArrow = floorplan.querySelector(".floorplan__arrows__item--right");
    let disabledArrow = "floorplan__arrows__item--disabled";

    if (leftArrow && rightArrow) {
        leftArrow.classList.remove(disabledArrow);
        rightArrow.classList.remove(disabledArrow);

        if (i === 0) {
            leftArrow.classList.add(disabledArrow);

        } else if (i === slides.length - 1) {
            rightArrow.classList.add(disabledArrow);
        }
    }
}
let mapStyles;

try{
    fetch(`${location.protocol + "//" + location.host}/wp-content/uploads/map-styles.json`).then((response) => {
        if(response.ok){
            return response.json();
        }else{
            if(response.status === 404){
            }else{
                // console.error(`Error: ${response.status}`);
            }
            return false;
        }
    }).then((responseJson) => {
        if(responseJson){
            mapStyles = responseJson;
        }
    }).catch((err) => {
        // console.log(err);
    });
}catch(err){
    // console.log(err);
}


function initGettingHere(){
    let maps = document.querySelectorAll(".getting-here__map");

    if(maps.length > 0){
        let mcOptions = {
            gridSize: 50,
            minimumClusterSize: 2,
            maxZoom: 12,
            zoomOnClick: false,

            styles: [
                {
                    textColor: "black",
                    url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
                    height: 53,
                    width: 53,
                    textSize: 11,
                }
            ]
        };

        loader.load().then(() => {
            let maps = document.querySelectorAll(".getting-here__map");

            maps.forEach(map => {
                let markers = map.querySelectorAll(".getting-here__map__marker");

                let gMap = new google.maps.Map(map, {
                    zoom: parseFloat(map.dataset.zoom),
                    center: {
                        lat: parseFloat(map.dataset.lat),
                        lng: parseFloat(map.dataset.lng)
                    },
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    styles: mapStyles
                });

                let cMarkers = [];
                markers.forEach(marker => {
                    let svg =
                        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="37px" height="49px" viewBox="0 0 37 49">
                        <defs>
                        <path id="a" fill-rule="nonzero" d="M18.5 0C8.299 0 0 7.96 0 17.746 0 29.889 16.556 47.717 17.26 48.47a1.714 1.714 0 0 0 2.48 0C20.443 47.717 37 29.89 37 17.746 37 7.96 28.7 0 18.5 0z"/>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)">
                        <use fill="#FE5D2A" fill-rule="evenodd" xlink:href="#a"/>
                        </g>
                        <text text-anchor="middle" dy="10px" x="19" y="15" font-family="Roboto, Arial, sans-serif" font-size="16px" fill="#323232"/>
                        </g>
                        </svg>`;

                    let gMarker = new google.maps.Marker({
                        position: {
                            lat: parseFloat(marker.dataset.lat),
                            lng: parseFloat(marker.dataset.lng)
                        },
                        map: gMap,
                        icon: {
                            url: "data:image/svg+xml;charset=UTF-8;base64," + btoa(svg),
                            size: new google.maps.Size(18 * 2, 18 * 2),
                            scaledSize: new google.maps.Size(18 * 2, 18 * 2),
                        },
                    });

                    let infowindow = new google.maps.InfoWindow({
                        content: `<span class="inner" style="background-color: #fff">${marker.dataset.label}</span>`,
                        disableAutoPan: true
                    });

                    cMarkers.push(gMarker);
                });

                let gCluster = new MarkerClusterer(gMap, cMarkers, mcOptions);

                google.maps.event.addListener(gCluster, "click", function (cluster){
                    gMap.fitBounds(cluster.getBounds());
                    gMap.setZoom(16);
                });
            });
        });
    }
}

jQuery(function ($){
    if(document.querySelector("#getting-here-directions")){
        loader.load().then(() => {
            if(typeof google === "undefined" || !("maps" in google)){
                $(document).on("googleMapReady", function (){
                    try{
                        gettinghereMap();
                    }catch(e){
                        console.log("Google map API is unavailable.");
                    }
                });
                console.log("map hook is defined");
            }else{
                gettinghereMap();
            }

            $("#getting-here-directions .defaultDestination a").on("keypress click", function (){
                $("#getting-here-directions .defaultDestination").hide();
                $("#getting-here-directions .customDestination").css("display", "flex");
            });

            // window.initialInteraction(gettinghereMap, "", 1000);
            // window.updateMapAfterRejection(gettinghereMap, "getting-here-directions", 1000);
        });
    }
});

let GH_directions_map = null;
let GH_suggestion_distance = 150;
let GH_defaultLocation = null;
let GH_defaultLocationTitle = null;
let directionsDisplay = null;
let markerStartLocation = null;
let markerEndLocation = null;
let markerBroadgate = null;

const compStyle = window.getComputedStyle(document.body);
let markerBrandColor = compStyle.getPropertyValue("--colour-primary");
let markerTextColor = compStyle.getPropertyValue("--colour-secondary");

/**
 * Map init
 */
function gettinghereMap(){
    let destinationData = jQuery(".filters .defaultDestination");
    GH_defaultLocation = new google.maps.LatLng({ lat: parseFloat(destinationData.attr("data-lat")), lng: parseFloat(destinationData.attr("data-lon")) });
    GH_defaultLocationTitle = destinationData.attr("data-title");
    GH_directions_map = gettinghereMap_initmap();
    directionsDisplay = new google.maps.DirectionsRenderer({
        polylineOptions: {
            strokeColor: markerTextColor,
            strokeWeight: 5,
            zIndex: 10000
        },
        suppressMarkers: true
    });

    let circle = new google.maps.Circle({
        radius: GH_suggestion_distance,
        center: GH_defaultLocation
    });

    try{
        let input = jQuery("#getting-here-directions #startpoint, #getting-here-directions #endpoint").each(function (index, elm){
            let autocomplete = new google.maps.places.Autocomplete(elm, {
                bounds: circle.getBounds()
            });
        });
    }catch(e){
        console.log("Google map Autocomplete is unavailable.");
    }

    markerBroadgate = new google.maps.Marker({
        position: GH_defaultLocation,
        // title: Drupal.settings.calippoMapMarkerTitle,
        icon: pinSymbol(markerBrandColor, markerTextColor, ""),
    });
    markerBroadgate.setMap(GH_directions_map);

    let onChangeHandler = function (){
        jQuery("#getting-here-directions .form-type-text").removeClass("error");
        gettinghereDisplayRoute();
    };
    jQuery("#getting-here-directions #startpoint, #getting-here-directions #mode, #getting-here-directions #endpoint").on("change", onChangeHandler);
}

/**
 * Init map object.
 */
function gettinghereMap_initmap(){
    return new google.maps.Map(jQuery("#getting-here-directions .map").get(0), {
        zoom: 15,
        center: GH_defaultLocation,
        mapTypeControl: false,
        styles: mapStyles
    });
}

/**
 * Map route request
 */
function gettinghereDisplayRoute(){
    let userInput = jQuery("#getting-here-directions #startpoint");
    let userInputEndPoint = jQuery("#getting-here-directions #endpoint");

    let trySuggestions = function (predictions, status){
        if(status != google.maps.places.PlacesServiceStatus.OK){
            directionsFails(GH_directions_map, status, userInput);
            return;
        }

        userInput.val(predictions[0].description);

        if(userInputEndPoint.val() === ""){
            directionsServiceStart(userInput.val(), GH_defaultLocation);

        }else{
            // stage2 - extractiong destination
            let service = new google.maps.places.AutocompleteService();
            service.getQueryPredictions({
                input: userInputEndPoint.val(),
                location: GH_defaultLocation,
                radius: GH_suggestion_distance
            }, tryFinalPointSuggestions);
        }
    };

    let tryFinalPointSuggestions = function (predictions, status){
        if(status != google.maps.places.PlacesServiceStatus.OK){
            directionsFails(GH_directions_map, status, userInputEndPoint);
            return;
        }

        userInputEndPoint.val(predictions[0].description);
        directionsServiceStart(userInput.val(), userInputEndPoint.val());
    };

    if(userInput.val().trim() != ""){
        jQuery("#getting-here-directions .map-container").addClass("search-way");

        // stage1 - extractiong startpoint location
        let service = new google.maps.places.AutocompleteService();
        service.getQueryPredictions({
            input: userInput.val(),
            location: GH_defaultLocation,
            radius: GH_suggestion_distance
        }, trySuggestions);
    }
}

/**
 * Use directions service
 */
function directionsServiceStart(startPoint, endPoint){

    if(startPoint.trim() != ""){
        let directionsService = new google.maps.DirectionsService;

        directionsService.route({
            origin: startPoint,
            destination: endPoint,
            region: "uk",
            travelMode: jQuery("#getting-here-directions #mode").val(),
        }, function (response, status){

            jQuery("#getting-here-directions .map-container").removeClass("search-way");

            if(status === "OK"){
                markerBroadgate.setMap(null);
                jQuery("#getting-here-directions .map-container").addClass("show-way");

                directionsDisplay.setMap(null);
                directionsDisplay.setMap(GH_directions_map);
                directionsDisplay.setPanel(jQuery("#getting-here-directions #way-path").get(0));

                if(typeof endPoint === "object"){
                    response.routes[0].legs[0].end_address = GH_defaultLocationTitle;
                }

                directionsDisplay.setDirections(response);

                if(markerStartLocation != null){
                    markerStartLocation.setMap(null);
                    markerEndLocation.setMap(null);
                }
                markerStartLocation = new google.maps.Marker({
                    position: response.routes[0].legs[0].start_location,
                    map: GH_directions_map,
                    icon: pinSymbol(markerBrandColor, markerTextColor, "A"),
                    title: response.routes[0].legs[0].start_address,
                });

                markerEndLocation = new google.maps.Marker({
                    position: response.routes[0].legs[0].end_location,
                    map: GH_directions_map,
                    icon: pinSymbol(markerBrandColor, markerTextColor, "B"),
                    // title: Drupal.settings.calippoMapMarkerTitle,
                });

                setTimeout(
                    function (){
                        // fixes map display
                        directionsRenewMap(GH_directions_map);
                        GH_directions_map.panToBounds(response.routes[0].bounds);
                    }, 500);
                //fix route draw bug
                setTimeout(
                    function (){
                        let z = GH_directions_map.getZoom();
                        GH_directions_map.setZoom(z - 1);
                    }, 700);
                setTimeout(
                    function (){
                        let z = GH_directions_map.getZoom();
                        GH_directions_map.setZoom(z + 1);
                    }, 800);

            }else{
                directionsFails(GH_directions_map, status, null);
            }
        });
    }
}

/**
 * Show error status
 */
function directionsFails(map, status, field){
    jQuery("#getting-here-directions .map-container").removeClass("show-way");
    // clear diresctions display
    directionsDisplay.setMap(null);
    //  directionsDisplay = new google.maps.DirectionsRenderer();
    directionsRenewMap(map);
    map.setZoom(11);
    map.panTo(GH_defaultLocation);

    switch(status){
    case"NOT_FOUND":
    case"ZERO_RESULTS":
        status = "Location not found.";
        break;
    case"OVER_QUERY_LIMIT":
        status = "The webpage has gone over the requests limit in too short a period of time.";
        break;
    case"MAX_WAYPOINTS_EXCEEDED":
        status = "Too many DirectionsWaypoints were provided in the DirectionsRequest.";
        break;
    }

    let fieldContainer = jQuery("#getting-here-directions .form-type-text");
    if(field != null){
        fieldContainer = jQuery(field).parent();
    }

    fieldContainer.addClass("error");
    fieldContainer.find(".error-message").html(status);
}

function directionsRenewMap(map){
    // fixes map display
    let center = map.getCenter();
    google.maps.event.trigger(map, "resize");
    map.setCenter(center);
}


function pinSymbol(color, textcolor, label){
    var template = [
        "<svg version=\"1.1\" width=\"37px\" height=\"49px\" viewBox=\"0 0 37 49\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">",
        "<defs>",
        "<path id=\"a\" fill-rule=\"nonzero\" d=\"M18.5 0C8.299 0 0 7.96 0 17.746 0 29.889 16.556 47.717 17.26 48.47a1.714 1.714 0 0 0 2.48 0C20.443 47.717 37 29.89 37 17.746 37 7.96 28.7 0 18.5 0z\"/>",
        "</defs>",
        "<g fill=\"none\" fill-rule=\"evenodd\">",
        "<g transform=\"translate(1 1)\">",
        "<use fill=\"{{ color }}\" fill-rule=\"evenodd\" xlink:href=\"#a\"/>",
        "</g>",
        "<text text-anchor=\"middle\" dy=\"10px\" x=\"19\" y=\"15\" font-family=\"Roboto, Arial, sans-serif\" font-size=\"16px\" fill=\"{{ textcolor }}\">{{ label }}</text>",
        "</g>",
        "</svg>"].join("\n");

    var svg = template.replace("{{ color }}", color).replace("{{ textcolor }}", textcolor).replace("{{ label }}", label);

    return{
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(40, 40)
    };
}
function initHeader(){
    const fixedHeader = document.querySelector(".header--fixed");
    const searchBtns = document.querySelectorAll(".header__nav__main__item--search__btn");
    const searchPopup = document.querySelector(".search-popup");

    if(searchPopup){
        const searchInput = searchPopup.querySelector("input");

        searchBtns.forEach(searchBtn => {
            searchBtn.addEventListener("click", function (e){
                e.preventDefault();
                searchPopup.classList.add("search-popup--active");
                scroller.paused(true);
                searchInput?.focus();
            });
        });

        const searchClose = document.querySelector(".search-popup__close");
        searchClose?.addEventListener("click", function (){
            scroller.paused(false);
            searchPopup.classList.remove("search-popup--active");
        });

        const searchClears = document.querySelectorAll(".search__form__controls__clear");
        searchClears.forEach(searchClear => {
            searchClear.addEventListener("click", function (e){
                e.preventDefault();

                const input = searchClear.parentElement.parentElement.querySelector("input");
                if(input){
                    input.value = "";
                    input.focus();
                }
            });
        });
    }

    document.addEventListener("wheel", function (e){
        if(e.deltaY > 3){
            fixedHeader.classList.remove("header--fixed--down");

        }else if(e.deltaY < -3){
            fixedHeader.classList.add("header--fixed--down");
        }
    });

    gsap.to(fixedHeader, {
        scrollTrigger: {
            trigger: "body",
            start: "top top",

            scroller: "body",

            onEnter: () => { fixedHeader.classList.remove("header--fixed--up"); },
            onLeaveBack: () => { fixedHeader.classList.add("header--fixed--up"); },
            onLeave: () => { fixedHeader.classList.add("header--fixed--up"); },
            onEnterBack: () => { fixedHeader.classList.remove("header--fixed--up"); },
        },
    });

    const toggle = document.getElementsByClassName("mbl-nav__toggle")[0];
    const mblNav = document.getElementsByClassName("mbl-nav")[0];

    toggle.addEventListener("click", function (e){
        mblNav.classList.toggle("mbl-nav--open");
        toggle.classList.toggle("mbl-nav__toggle--active");
        fixedHeader.classList.remove("header--fixed--down");

        scroller.paused(!scroller.paused());
    });
}

function initHero(){
    let heroAnchor = document.getElementsByClassName("hero__anchor")[0];
    if(heroAnchor){
        gsap.fromTo(heroAnchor, { opacity: 1, scale: 1 }, {
            opacity: 0,
            scale: .8,

            scrollTrigger: {
                trigger: ".hero",
                scrub: true,
                start: "top top",
                end: "bottom-=50% top",
                once: false,

                onEnter: () => { gsap.to(heroAnchor, { pointerEvents: "all" }); },
                onLeaveBack: () => { gsap.to(heroAnchor, { pointerEvents: "none" }); },
                onLeave: () => { gsap.to(heroAnchor, { pointerEvents: "none" }); },
                onEnterBack: () => { gsap.to(heroAnchor, { pointerEvents: "all" }); },
            }
        });

        heroAnchor.addEventListener("click", function (){
            scroller.scrollTo(".hero + *", true, "top 100px");
        });
    }

    if(document.querySelectorAll(".hero--parallax").length > 0){
        gsap.fromTo(".hero__parallax__title--left", { xPercent: -3 }, {
            xPercent: 0,

            scrollTrigger: {
                trigger: ".hero__parallax",
                start: "top top",
                end: "bottom top",
                scrub: true,
            }
        });

        gsap.fromTo(".hero__parallax__title--right", { xPercent: 3 }, {
            xPercent: 0,

            scrollTrigger: {
                trigger: ".hero__parallax",
                start: "top top",
                end: "bottom top",
                scrub: true,
            }
        });

        gsap.fromTo(".hero--parallax .hero__bg--overlay:not(.hero__bg--overlay--light)", { filter: "brightness(.8)" }, {
            filter: "brightness(.5)",

            scrollTrigger: {
                trigger: ".hero__parallax",
                start: "top top",
                end: "bottom top",
                scrub: true,
            }
        });

        gsap.fromTo(".hero--parallax .hero__bg--overlay.hero__bg--overlay--light", { filter: "brightness(.6)" }, {
            filter: "brightness(.5)",

            scrollTrigger: {
                trigger: ".hero__parallax",
                start: "top top",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    if(document.querySelectorAll(".hero video").length > 0){
        gsap.to(".hero video", {
            scrollTrigger: {
                trigger: ".hero video",
                start: "top bottom",
                end: "bottom top",

                onEnter: (e) => { e.trigger.play(); },
                onLeaveBack: (e) => { e.trigger.pause(); },
                onLeave: (e) => { e.trigger.pause(); },
                onEnterBack: (e) => { e.trigger.play(); },
            }
        });
    }
    const archiveSearch = document.querySelector(".archive__banner__item__search");
    if(archiveSearch){
        const clearSearch = archiveSearch.querySelector(".archive__banner__item__search__btn");
        const form = archiveSearch.querySelector(".archive__banner__item__search__form");

        clearSearch?.addEventListener("click", function (e){
            e.preventDefault();
            form.reset();
        });
    }
    if(document.querySelectorAll(".hero--height-anim").length > 0){
        gsap.fromTo(".hero--height-anim", { height: "100vh" }, {
            height: "80vh",
            duration: .8,
            delay: .6,
            ease: "Power3.easeInOut",
            onComplete: () => ScrollTrigger.refresh()
        });
    }
}
import Swiper from "swiper";

let scroller: object;

function initScroller() {
    scroller = ScrollSmoother.create({
        smooth: 0.01,
        smoothTouch: 0,

        normalizeScroll: false,
        ignoreMobileResize: true,
        effects: false
    });

    if (document.querySelector("main.has-parallax")) {
        const parallaxEls = document.querySelectorAll(".parallax")
        gsap.set(parallaxEls, {
            willChange: "transform",
            scale: 1.13
        })

        scroller.effects(parallaxEls, { speed: .93 })
    }

    initGlobalAos();
    initMiscAos();

    const jumpLinks = document.querySelectorAll(`[href^="#"]`);
    jumpLinks.forEach(jumpLink => {
        jumpLink.addEventListener("click", function (e) {
            e.preventDefault();
            const href = jumpLink.getAttribute("href").split("?");
            scroller.scrollTo(href[0], true, "top 100px");

            if (href[1] && href[0].includes("video-slider")) {
                const videoSlider = document.querySelector(href[0]);
                videoSlider.swiper?.slideTo(href[1]);
            }
        })
    });

    let locationHash = window.location.hash
    if (locationHash) {
        if (locationHash.includes("?")) {
            const href = locationHash.split("?");
            scroller.scrollTo(href[0], true, "top 100px");

            if (href[1] && href[0].includes("video-slider")) {
                setTimeout(() => {
                    const videoSlider = document.querySelector(href[0]);
                    videoSlider.swiper?.slideTo(href[1]);
                }, 500);
            }

        } else if (!locationHash.includes("msdynmkt_trackingcontext")) {
            const hashElement = document.querySelector(locationHash)
            if (hashElement) scroller.scrollTo(hashElement, true, "top 100px");
        }
    }
}

function initGlobalAos() {
    let sectionFade = document.querySelectorAll(".fade-el");
    sectionFade.forEach(el => {
        gsap.fromTo(el, { opacity: 0, y: 25 }, {
            opacity: 1,
            y: 0,
            ease: "ease",
            duration: 1.4,

            scrollTrigger: {
                trigger: el,
                start: "top bottom-=5%",
                end: "bottom top",
            }
        });
    });
}

function initMiscAos() {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 1152px)", () => {
        gsap.to(".text__col__wrap", {
            scrollTrigger: {
                trigger: ".text__col--sticky",
                endTrigger: ".text--sticky",
                pin: true,
                start: `top-=15 top+=${document.querySelector(".header--fixed").clientHeight}`,
                end: "bottom top",
            },
            duration: 0,
            ease: "linear"
        });
    })

    gsap.fromTo(".latest__grid__item", { opacity: 0 }, {
        opacity: 1,
        duration: .8,
        ease: "ease-out",
        stagger: .2,

        scrollTrigger: {
            trigger: ".latest__grid",
            scrub: false,
            start: "top bottom-=5%",
            end: "bottom bottom",
        }
    });

    let lines = document.querySelectorAll(".spacer.spacer--line");
    lines.forEach(line => {
        gsap.to(line, {
            scrollTrigger: {
                trigger: line,
                start: "top bottom-=5%",
                end: "bottom bottom",

                onEnter: () => {
                    line.classList.add("spacer--line--scroll");
                }
            }
        });
    });

    let halves = document.querySelectorAll(".half");
    halves.forEach(half => {
        gsap.fromTo(half.querySelector(".half__mask"), { y: -10 + "%" }, {
            y: 100 + "%",
            duration: 2,
            ease: "ease-in",

            scrollTrigger: {
                trigger: half,
                start: "top bottom-=5%",
                end: "bottom bottom",
            }
        });
    });

    const spaces = document.querySelector(".spaces");
    const spacesBtn = document.querySelector(".spaces__btn");
    const spaceCompare = document.querySelector(".space-compare");

    if (spaceCompare) {
        if (spaces && spacesBtn) {
            gsap.to(spacesBtn, {
                scrollTrigger: {
                    trigger: spacesBtn,
                    start: "bottom bottom",
                    endTrigger: spaces,
                    end: "bottom-=80 bottom",
                    pin: true,
                }
            })
        }
    } else spacesBtn?.remove();
}
function initScripts(){
    initHeader();
    initHero();
    initPromo();
    initEalingHomePromo();
    initScroller();
    initSliders();
    initArchive();
    initFPSlider();
    initDetail();
    initWalkthrough();
    initPopups();
    initShowtimes();
    initCustomSelect();
    initGettingHere();
    initWpcf7Redirect();
    storeUTMs();
    initNewsslider();
    initFeaturedSlider();
    initPanelSlider();
    initMarquee();
    initDualCta();
    initSparkleCursor();
}

import imagesLoaded from"imagesloaded";

function pageLoader(){
    if(document.body.classList.contains("home")){
        const imgLoad = imagesLoaded(document.documentElement);

        imgLoad.on("done", () => {
            let tl = gsap.timeline();
            tl.to(".page-loader__logo", { opacity: 0, duration: 0.1 });
            tl.to(".page-loader", { opacity: 0, pointerEvents: "none", duration: 0.1 });
            tl.to("#smooth-content", { opacity: 1, duration: 0.1 });
        });

    }else{
        gsap.set(".page-loader", { opacity: 0, pointerEvents: "none", duration: 0.1 });
        gsap.set("#smooth-content", { opacity: 1, duration: 0.1 });
    }
}

window.addEventListener("DOMContentLoaded", runLoader);
function runLoader(){
    initScripts();

    if(document.querySelector(".page-loader")){
        const videos = document.querySelectorAll("video");
        const autoplayingVideos = Array.from(videos).filter((video) =>
            video.hasAttribute("autoplay")
        );

        if(autoplayingVideos.length > 0){
            let loadedVideosCount = 0;

            for(let i = 0; i < autoplayingVideos.length; i++){
                autoplayingVideos[i].addEventListener("loadeddata", () => {
                    loadedVideosCount++;
                    if(loadedVideosCount === autoplayingVideos.length) pageLoader();
                });
            }
        }else pageLoader();
    }else gsap.set("#smooth-content", { opacity: 1 });
}

import gsap from "gsap";
gsap.defaults({ ease: "ease" });

gsap.config({
    nullTargetWarn: false,
    force3D: false,
    autoSleep: 60
});

import ScrollSmoother from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let innerH = window.innerHeight;
let innerW = window.innerWidth;
document.addEventListener("resize", function () {
    innerH = window.innerHeight;
    innerW = window.innerWidth;
});

import { Loader, LoaderOptions } from "google-maps";
const options: LoaderOptions = { libraries: ["places"] };
import MarkerClusterer from "@googlemaps/markerclustererplus";

const loader = new Loader("AIzaSyDan4G6oDpKLxuFyAypSP5MMx_1Im4LI_c", options);

import jQuery from "jquery";
const $ = jQuery;

import L from "leaflet/dist/leaflet";
/**
 * Initialization of DOM map container to view dynamic local map.
 * @map_id - DOM container ID
 * @data - input data
 */
function appmap_init(map_id, data) {
    if (typeof (data) == "string") {
        data = JSON.parse(data.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t"));
    }

    console.log(data);

    var el = document.getElementById(map_id)

    if (el.dataset.width) {
        data.w = el.dataset.width
    }

    if (el.dataset.height) {
        data.h = el.dataset.height
    }

    let w = data.w,
        h = data.h,
        ibounds = L.latLngBounds(L.latLng(0, 0), L.latLng(h, w))
    let zm = data.zoom;

    // if (document.querySelector("body.single-eatdrinkshop")) {
    //     zm = data.retailerZoom
    //     data.zoom = data.retailerZoom
    // } else {
    //     zm = data.zoom;
    // }

    if (jQuery(el).parents(":hidden").length || jQuery(el).hasClass("map-ready")) {
        // we can't init map if block is hidden
        console.log("Map is hidden or already has been initialized.");
        return false;
    }

    if (data.zoomAuto) {
        zm = L.doms.getOptimalZoom(el, w, h, data.zoom);
        data.zoomin = zm - 1;
        data.zoomax = zm + 1;
    }

    var mapSettings = {
        crs: L.CRS.Simple,
        minZoom: Number(data.zoomin),
        maxZoom: Number(data.zoomax),
        tap: false,
        zoomSnap: 0.005,
        zoomDelta: 0.5,
        zoom: Number(zm),
        zoomControl: 0,
        doubleClickZoom: false,
        scrollWheelZoom: data.zoomMousewheel,
        data: data
    };

    if (data["AutoFit"]) {
        var fitBounds = L.latLngBounds(ibounds.getSouthWest(), ibounds.getNorthEast()).pad(data["FitMargin"] / 100);
        mapSettings.maxBounds = fitBounds;
    }

    if (data.markerSize) {
        jQuery(el).addClass("multilevel-el");
    }

    var map = L.map(map_id, mapSettings);

    // detect teaser mode
    var teaserMode = jQuery(el).hasClass("node-teaser");

    // zoom control settings
    if (data.zoomControl) {
        var ZOOM = L.control.zoom({
            position: "bottomright",
        });
        ZOOM.addTo(map);
    }

    // swiping behavior
    // on >= 2 touching it enables swipe (dragging)
    el.addEventListener("touchstart", function (e) {
        try {
            var map = L.doms.get(this.id);
            if (e.touches.length >= 2) {
                map.dragging.enable();
            } else {
                map.dragging.disable();
            }
        } catch (err) {
            //      alert('Error ' + err.name + ":" + err.message + "\n" + err.stack + "\n" + JSON.stringify(e));
        }
    }, false);
    el.addEventListener("touchend", function (e) {
        if (e.touches.length < 2) {
            var map = L.doms.get(this.id);
            map.dragging.disable();
        }
    }, false);
    el.addEventListener("click", function (e) {
        var hasMarkerClass = e.target.classList.contains("multilevel-icon");
        var hasPopupClass = e.target.classList.contains("leaflet-popup-content");
        var hasPopupWrapperClass = e.target.classList.contains("leaflet-popup-content-wrapper");
        var hasCustomPopupClass = e.target.classList.contains("custom-popup");
        map.dragging.disable();
        if (!hasMarkerClass && !hasPopupClass && !hasPopupWrapperClass && !hasCustomPopupClass) {
            jQuery(el).find(".leaflet-image-layer").attr("data-visibility", "");
            jQuery(el).find(".multilevel-icon").attr("data-visibility", "");
            map.dragging.enable();
        }
        if (!hasMarkerClass && !hasCustomPopupClass && !L.doms.isMobile()) {
            jQuery(el).find(".custom-popup .popup-close").trigger("click");
        }
    }, false);
    // define bg color
    try {
        el.style.backgroundColor = "#" + data.bgColor;
    } catch (e) {

    }

    let handler_id = L.doms.register(map_id, map);

    // Add BG layers
    for (var k = 0; k < data.urls.length; k++) {
        var LR = L.imageOverlay(data.urls[k], ibounds).addTo(map);
        LR.options.title = "BG";
    }

    jQuery(map._container).parent().append("<div style=\"display: none\" class=\"preload-assets\"></div>");
    var preloadAsssets = jQuery(map._container).parent().find(".preload-assets");

    // calc max Bounds for panning
    var maxSize = {
        w: 0,
        h: 0
    };

    // Add active markers
    for (var k = 0; k < data.markers.length; k++) {
        var M = data.markers[k];
        if (!M.points.length) {
            continue;
        }
        M.title = decodeURIComponent(M.title.replace(/\+/g, " "));
        try {
            M.popup.content = M.popup.content.replace(/\+/g, " ");
        } catch (err) {
            console.error("Error decoding M.popup.content:", M.popup.content, err);
        }

        switch (M.type) {
            case "dots":
                if (M.active) {
                    L.doms.addMarker(map, k);
                }

                // add image to pleload assets area
                if (M.imageurl !== undefined) {
                    if (preloadAsssets.find(".marker-" + k).length == 0) {
                        var img = document.createElement("IMG");
                        img.setAttribute("src", M.imageurl);
                        img.setAttribute("class", "marker-" + k);
                        preloadAsssets.get(0).appendChild(img);
                    }
                }

                break;

            case "dot":
                L.doms.addMarker(map, k);

                // add image to pleload assets area
                if (M.imageurl !== undefined) {
                    if (preloadAsssets.find(".marker-" + k).length == 0) {
                        var img = document.createElement("IMG");
                        img.setAttribute("src", M.imageurl);
                        img.setAttribute("class", "marker-" + k);
                        preloadAsssets.get(0).appendChild(img);
                    }
                }

                break;

            case "polygon":
                var PL = L.doms.addMarker(map, k);
                var BDS = PL.getBounds().pad(0.25);
                var maxObjW = BDS.getEast() - BDS.getWest();
                var maxObjH = BDS.getNorth() - BDS.getSouth();

                if (maxObjW > maxSize.w) {
                    maxSize.w = maxObjW;
                }
                if (maxObjH > maxSize.h) {
                    maxSize.h = maxObjH;
                }
                break;

            case "dotpolygon":
                var PL = L.doms.addMarker(map, k);
                var BDS = PL.getBounds().pad(0.25);
                var maxObjW = BDS.getEast() - BDS.getWest();
                var maxObjH = BDS.getNorth() - BDS.getSouth();

                if (maxObjW > maxSize.w) {
                    maxSize.w = maxObjW;
                }
                if (maxObjH > maxSize.h) {
                    maxSize.h = maxObjH;
                }
                break;
        }

        // create filter element
        if (M.infilter) {
            L.doms.maps[handler_id].filter.addGroup(M.group);
            L.doms.maps[handler_id].filter.addElement({
                group: M.group,
                title: M.title,
                keywords: decodeURIComponent(M.keywords.replace(/\+/g, " ")),
                active: M.active,
                marker_id: k,
            });
        }
    }

    // hide filter on empty list
    var $F = jQuery(L.doms.maps[handler_id].filter.container);
    if (!$F.find(".list-wrapper .list .element").length) {
        $F.hide();
    }

    map.options.data.maxPanSize = maxSize;

    // initial panning and zooming
    L.appmap_pan_n_zoom(map);

    //marker activation
    if (data.activateMarker != undefined) {
        if (data.activateMarker.rel == 1) {
            // full match
            var M = $F.find("[data-marker-id=\"" + data.activateMarker.marker_id + "\"]");
            M.trigger("click");
            if (teaserMode) {
                var nodeRetailer = jQuery(el).parents().find(".node-retailer");
                var nodeRetailerClass = nodeRetailer[0].dataset.id;
                var markers = data.markers;
                markers.forEach(function (item, i, markers) {
                    if (item.type == "dot") {
                        var M = jQuery(el).find("." + item.nid);
                        if (item.retailer != nodeRetailerClass) {
                            M.hide();
                        }
                    }
                });
                //close custom-popup for initial node-teaser marker
                if (data.markers[data.activateMarker.marker_id].type != "dot") {
                    jQuery(el).find(".leaflet-popup-pane").empty();
                }
            }
            if (M.length > 0) {
                L.doms.maps[handler_id].filter.openGroup(M.get(0));
            }
        } else {
            // partial match
            var I = $F.find(".search-element input");
            I.get(0).value = data.activateMarker.query;
            I.trigger("change");
        }
    }

    // activate first trail point
    if (data.widget == "trail") {
        L.doms.setActiveTrail(map, 0, 0);
    }

    jQuery(el).addClass("map-ready");

    // controls
    if (data.widget == "interactive") {
        var wrapper = jQuery(el).parents(".map-wrapper");
        var controls = wrapper.find(".map-controls");
        controls.find(".control-locations").on("click", function () {
            wrapper.children(".locations").toggle();
        });
        controls.find(".control-street-view-mode").on("click", function () {
            wrapper.removeClass("map-mode").addClass("view-mode");
            setUrlChunk(3, "street-view");
        });
        controls.find(".control-map-view-mode").on("click", function () {
            wrapper.removeClass("view-mode").addClass("map-mode");
            wrapper.children(".locations").hide();
            setUrlChunk(3, "");
        });

        wrapper.children(".locations").find(".location-title").on("click", function () {
            wrapper.children(".locations").hide();
            var F = jQuery(this).data("code");
            wrapper.children(".street-view").html(decodeURIComponent(F.replace(/\+/g, " ")));
        });

        // default location embed code
        var defLocation = wrapper.children(".locations").find(".location-title[data-default=\"1\"]");
        if (!defLocation.length) {
            defLocation = wrapper.children(".locations").find(".location-title");
        }
        var F = defLocation.data("code");
        if (F !== null) {
            if (wrapper.children(".street-view").length > 0) {
                wrapper.children(".street-view").html(decodeURIComponent(F.replace(/\+/g, " ")));
            }
        }
    }
}

(function ($) {
    $(document).bind("leafletIsLoaded", function (e) {

        /**
         * Create L <==> DOM associations storage
         */
        $.extend(true, L, {

            /**
             * Play zoom animation
             */
            appmap_zoominPlay: function (map, zoom, zoomDelta) {
                map.setMinZoom(zoom - zoomDelta);
                map.setZoom(zoom - zoomDelta, { animate: false });
                map.setMinZoom(zoom - zoomDelta);
                map.flyTo(map.getCenter(), zoom, {
                    animate: true,
                    duration: 0.5
                });
            },

            /**
             * Initial pan and zoom
             */
            appmap_pan_n_zoom: function (map) {
                //go to initial center of the map
                map.setZoom(map.options.data.zoom);
                map.panTo([
                    map.options.data.h * (1 - map.options.data.valign / 100),
                    map.options.data.w * (map.options.data.halign / 100)]);

                if (map.options.data.zoominPlay) {
                    try {
                        L.appmap_zoominPlay(map, map.options.data.zoom, 3);
                    } catch (err) {

                    }
                }
            },

            /**
             * Remove layers with given title
             */
            appmap_remove_layers: function (map, title) {
                map.eachLayer(function (layer) {
                    if (layer.options.title == title) {
                        map.removeLayer(layer);
                    }
                });
            },

            appmap_hide_layer: function (map, marker_id) {
                var LR = L.doms.getLayerByMarkerID(map, marker_id);

                switch (map.options.data.markers[marker_id].type) {
                    case "dots":
                        map.removeLayer(LR);
                        break;
                    case "polygon":
                        LR.options.active = 0;
                        LR.fire("mouseout");
                        break;
                }
            },

            appmap_show_layer: function (map, marker_id) {
                var LR = L.doms.getLayerByMarkerID(map, marker_id);

                switch (map.options.data.markers[marker_id].type) {
                    case "dots":
                        L.doms.addMarker(map, marker_id);
                        break;
                    case "polygon":
                        LR.options.active = 1;
                        LR.fire("mouseout");
                        break;
                }
            },

            doms: {
                maps: [],
                // get MapOBJ by DOM ID.
                get: function (mapID) {

                    var handler = this.findHandler(mapID);
                    if (handler === null) {
                        return handler;
                    }

                    return handler.obj;
                },

                /* remove map from list */
                remove: function (mapID) {
                    for (var k = 0; k < this.maps.length; k++) {
                        if (this.maps[k].id == mapID) {
                            this.maps.splice(k, 1);
                            return true;
                        }
                    }
                    return false;
                },

                getByAnyChild: function (domelm) {
                    var id = $(domelm).parents(".map-wrapper").children(".node-map").attr("id");
                    return this.get(id);
                },

                getOptimalZoom: function (el, w, h, defValue) {
                    var zm;

                    try {
                        zw = $(el).width() / w;
                        zh = $(el).height() / h;
                        zm = Math.log2(Math.max(zw, zh));
                        console.log("Auto-zoom value is " + zm);
                    } catch (err) {
                        console.log("Auto-zoom error");
                        zm = defValue;
                    }
                    return zm;
                },

                // get Map handler by DOM ID.
                findHandler: function (mapID) {
                    for (var k = 0; k < this.maps.length; k++) {
                        if (this.maps[k].id == mapID) {
                            return this.maps[k];
                        }
                    }
                    return null;
                },

                //Mobile?
                isMobile: function () {
                    return $(window).width() < 768;
                },

                setActiveTrail: function (map, marker_id, fitToTop) {
                    var lstContainer = $(map._container).parents(".map-trail").find(".list-wrapper .list");

                    if (L.doms.isMobile()) {

                        if (lstContainer.find(".item.active").attr("data-id") != marker_id) {
                            lstContainer.find(".item.active").removeClass("active");
                            lstContainer.find(".item[data-id=\"" + marker_id + "\"]").addClass("active");
                            lstContainer.find(".item .content").hide();
                            lstContainer.find(".item.active .content").show(2);
                        }

                        if (fitToTop) {
                            //scroll to map top
                            $("html, body").animate({
                                scrollTop: $(map._container).parents(".map-trail").offset().top
                            }, 250);
                        }

                    } else {

                        if (lstContainer.find(".item.active").attr("data-id") != marker_id) {
                            lstContainer.find(".item.active").removeClass("active");
                            lstContainer.find(".item[data-id=\"" + marker_id + "\"]").addClass("active");
                        } else {
                            lstContainer.find(".item.active").removeClass("active");
                        }

                        lstContainer.find(".item .content").hide(150);
                    }

                    var M = map.options.data.markers[marker_id];
                    map.eachLayer(function (layer) {
                        if (layer.options.type !== undefined && layer.options.type == "dot") {
                            layer.setStyle({
                                fillColor: layer.options.marker_id == marker_id ? layer.options.textcolor : layer.options.bgcolor,
                                fillOpacity: 1,
                            }).redraw();
                            var TL = layer.getTooltip();
                            if (layer.options.marker_id == marker_id) {
                                $(TL._container).addClass("active");
                                map.panTo(layer.getLatLng());
                            } else {
                                $(TL._container).removeClass("active");
                            }
                        }
                    });

                },

                getLayerByMarkerID: function (map, marker_id) {
                    var LR = null;
                    map.eachLayer(function (layer) {
                        if (layer.options.marker_id == marker_id) {
                            LR = layer;
                        }
                    });
                    return LR;
                },

                customPopup: {
                    open: function (layer) {
                        var M = layer._map.options.data.markers[layer.options.marker_id];

                        // TOGGLING POPUP
                        if (layer.isPopupOpen()) {
                            this.close(layer);
                            return false;
                        }
                        if ($(layer._map._container).find(".custom-popup.marker-id-" + layer.options.marker_id).length) {
                            this.close(layer);
                            return false;
                        }

                        // Analisys of popup settings
                        if (M.popup.content.length) {
                            var buildingLevel = "";
                            if (M.buildinglevel) {
                                if (String(M.buildinglevel).toLowerCase() != "ground floor") {
                                    buildingLevel = "<div class=\"popup-level\">Level " + M.buildinglevel + "</div>";
                                } else {
                                    buildingLevel = "<div class=\"popup-level\">" + M.buildinglevel + "</div>";
                                }
                            }
                            var popup_content = (M.popup.image == "" ? "" : "<div class=\"image\" style=\"background-image: url(" + M.popup.image + ")\"></div>")
                                + "<h2>" + (M.popup.titleUrl ? "<a target=\"_blank\" href=\"" + M.popup.titleUrl + "\">" + M.title + "</a>" : M.title) + "</h2>"
                                + buildingLevel
                                + "<div class=\"draggable-content\">" + M.popup.content;

                            // desktop link
                            var desktop_link = "";
                            var mobile_link = "";
                            var both_link = "";

                            if (M.popup.link.url.length) {
                                if (M.popup.link.title.length) {
                                    desktop_link = "<a class=\"more\" href=\"" + M.popup.link.url + "\">" + M.popup.link.title + "</a>";
                                } else {
                                    desktop_link = "<a class=\"more\" href=\"" + M.popup.link.url + "\">More details</a>";
                                }
                            }

                            // both link
                            if (M.popup.geo.lat !== undefined) {
                                both_link = "<a class=\"more\" href=\"/getting-here/directions?point=" + M.nid + "\">Get directions</a>";
                            }

                            popup_content += "<div class=\"for-desktop\">" + desktop_link + "</div><div class=\"for-both\">" + both_link + "</div><div class=\"for-mobiles\">" + mobile_link + "</div>";
                            popup_content += "</div>"; // for draggable-content

                            var POPUP = L.popup({ maxWidth: 260 })
                                .setContent(popup_content);

                            var popupCenter = layer.getBounds().getCenter();

                            // adjust popup position for DOTS
                            if (typeof M.center !== "undefined" && M.type !== "dot") {
                                popupCenter.lat += Number(M.center[1]);
                                popupCenter.lng += Number(M.center[0]);
                            }
                            if (M.type == "polygon") {
                                /*              var nodeRetailer = jQuery(el).parents().find('.node-retailer');
                                              if(nodeRetailer.length !== 0) {
                                                var sheet = document.createElement('style');
                                                sheet.classList.add("polygonstyle");
                                                var styleString = ".node-type-retailer .map-wrapper .node-map div.leaflet-popup {top:-250px !important;}";
                                                styleString += ".node-type-retailer .map-wrapper .node-map .leaflet-popup .leaflet-popup-tip-container {top: initial; bottom: 20px}";
                
                                                sheet.innerHTML = styleString
                                                document.body.appendChild(sheet);
                                              } else {
                                                popupCenter.lat += 20;
                                              }*/
                            }
                            POPUP.setLatLng(popupCenter);
                            layer.bindPopup(POPUP);

                        } else {
                            return false;
                        }

                        if (!L.doms.isMobile()) {
                            layer.openPopup(POPUP.getLatLng());
                            if (M.type == "polygon") {
                                let bnds = L.latLngBounds(layer._bounds.getNorthWest(), layer._bounds.getSouthEast());
                                bnds.extend([bnds.getNorth(), 2 * bnds.getEast() - bnds.getWest()]);
                                layer._map.flyToBounds(bnds, { padding: [20, 30] });
                            }
                        } else {
                            // custom popup layer
                            var cpl = document.createElement("DIV");
                            cpl.setAttribute("class", "custom-popup marker-id-" + layer.options.marker_id + (M.popup.image ? " with-image" : ""));
                            cpl.innerHTML = layer._popup._content + "<div class=\"popup-close\">&times;</div>";

                            layer._map._container.appendChild(cpl);

                            $(cpl).find(".popup-close").on("click", function () {
                                $(this).parent().remove();
                            });
                        }

                        $(layer._map._container).find(".field-name-field-retailer-optime .field-label").click(function () {
                            $(this).toggleClass("show");
                        });

                        //attach content scrollbar (for mobiles)
                        $(layer._map._container).find(".field-name-field-retailer-optime .field-label");
                        //$(layer._map._container).find('.leaflet-popup-content .draggable-content, .custom-popup .draggable-content').mCustomScrollbar({ scrollbarPosition: 'inside', });

                        // task: activate script DynamicOpeiningStatus of retailer.js
                        //Drupal.attachBehaviors(document, Drupal.settings);

                        //$(layer._map._container).find('.leaflet-popup-content .draggable-content, .custom-popup .draggable-content').mCustomScrollbar("update");
                    },
                    close: function (layer) {
                        layer.closePopup();
                        $(layer._map._container).find(".custom-popup").remove();
                        //          var polygonstyle = jQuery(el).parents().find('.polygonstyle');
                        //          polygonstyle.remove();
                    },
                },

                addMarker: function (map, marker_id) {
                    var M = map.options.data.markers[marker_id];

                    switch (M.type) {
                        case "dots":

                            if (map.options.data.widget == "trail") {
                                // like art trail markers

                                var G = L.featureGroup();
                                G.options.type = "dot-group";
                                G.options.marker_id = marker_id;
                                G.options.inFilter = M.infilter;

                                var myRenderer = L.svg();

                                var circle = L.circleMarker(L.latLng(M.points[0][0], M.points[0][1]), {
                                    marker_id: marker_id,
                                    bgcolor: M.bgcolor,
                                    textcolor: M.textcolor,

                                    renderer: myRenderer,
                                    title: M.title,
                                    stroke: false,
                                    fillColor: M.bgcolor,
                                    fillOpacity: 1,
                                    color: M.textcolor,
                                    radius: M.size[0] / 2,
                                    className: "marker-" + marker_id + " " + M.class,
                                    "type": "dot",
                                }).bindTooltip(M.litera, {
                                    permanent: true,
                                    direction: "center",
                                    opacity: 1,
                                    className: "litera marker-" + marker_id + " " + M.class,
                                }).on("click", function () {
                                    L.doms.setActiveTrail(map, marker_id, 1);
                                });
                                G.addLayer(circle);

                                var iconBase = [
                                    {
                                        name: "start",
                                        url: "data:image/png;base64,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",
                                        size: [98, 36],
                                    },
                                    {
                                        name: "finish",
                                        url: "data:image/png;base64,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",
                                        size: [102, 38],
                                    }
                                ];

                                for (var i = 0; i < iconBase.length; i++) {
                                    if (M.class.indexOf(iconBase[i].name) != -1) {
                                        // fit to current merker size
                                        var iconZoom = M.size[0] * 1.2 / iconBase[i].size[0],
                                            iconSizeW = iconBase[i].size[0] * iconZoom,
                                            iconSizeH = iconBase[i].size[1] * iconZoom,
                                            myIcon = L.icon({
                                                iconUrl: iconBase[i].url,
                                                iconSize: [iconSizeW, iconSizeH],
                                                iconAnchor: [iconSizeW / 2, iconSizeW * 0.75],
                                            });
                                        var marker = L.marker(L.latLng(M.points[0][0], M.points[0][1]));
                                        marker.setIcon(myIcon);
                                        G.addLayer(marker);
                                        break;
                                    }
                                }

                                // add marker to list
                                var lstContainer = $(map._container).parents(".map-trail").find(".list-wrapper .list").get(0);
                                var item = document.createElement("DIV");
                                item.setAttribute("class", "item marker-" + marker_id + " " + M.class);
                                item.setAttribute("data-id", marker_id);
                                item.innerHTML = "<div class=\"head row\">\
                <div class=\"litera col-xs-1\">" + M.litera + "</div>\
                <div class=\"title col-xs-10\">" + M.title + "</div>\
              </div>\
              <div class=\"content\">\
                <div class=\"description\">" + M.popup.content + "</div>\
              </div>";
                                $(item).on("click", function () {
                                    L.doms.setActiveTrail(map, $(this).attr("data-id"), 1);
                                });
                                lstContainer.appendChild(item);
                                //attach content scrollbar (for mobiles)

                                G.addTo(map);

                            } else {
                                // like getting-here/around amenities

                                var G = L.featureGroup();
                                G.options.type = "dot-group";
                                G.options.marker_id = marker_id;
                                G.options.inFilter = M.infilter;

                                var myIcon = null;
                                if (M.imageurl !== undefined) {
                                    var myIcon = L.icon({
                                        iconUrl: M.imageurl,
                                        iconSize: M.size,
                                        iconAnchor: M.center,
                                    });
                                }

                                for (var j = 0; j < M.points.length; j++) {
                                    var marker = L.marker(
                                        L.latLng(M.points[j][0], M.points[j][1]), {
                                        title: M.title,
                                        "type": "dot"
                                    });
                                    if (myIcon != null) {
                                        marker.setIcon(myIcon);
                                    }
                                    G.addLayer(marker);
                                }

                                G.addTo(map)
                                    .on("click", function (e) {
                                        L.doms.customPopup.open(this);
                                        // it doest work for some reason
                                        L.DomEvent.stopPropagation(e);
                                        // raise error to stop leaflet bubbling
                                        throw ("Stop the bubbling");
                                    });
                            }

                            break;
                        case "dot":

                            var G = L.featureGroup();
                            G.options.type = "dot-group";
                            G.options.marker_id = marker_id;
                            G.options.inFilter = M.infilter;

                            var myIcon = null;
                            if (M.imageurl !== undefined) {
                                var myIcon = L.icon({
                                    iconUrl: M.imageurl,
                                    iconSize: M.size,
                                    iconAnchor: M.center,
                                });
                            }

                            for (var j = 0; j < M.points.length; j++) {
                                var marker = L.marker(
                                    L.latLng(M.points[j][0], M.points[j][1]), {
                                    title: M.title,
                                    "type": "dot",
                                });
                                var myIcon = L.divIcon({ className: String(M.buildinglevel).toLocaleLowerCase().replace(" ", "-") + "-level " + M.nid + " multilevel-icon", html: M.dotnumber });
                                if (myIcon != null) {
                                    marker.setIcon(myIcon);
                                }
                                G.addLayer(marker);

                                marker.on("click", function () {
                                    var activeLevel = this.options.icon.options.className.split("-level")[0];
                                    $(".leaflet-interactive").attr("data-visibility", "");
                                    $(".leaflet-interactive").attr("data-visibility", "level-invisible");
                                    $(".leaflet-image-layer").attr("data-visibility", "level-invisible");
                                    $("." + activeLevel + "-level").attr("data-visibility", "level-visible");
                                    $(".map-level-label").remove();
                                    if (M.buildinglevel !== null) {
                                        if (String(M.buildinglevel).toLowerCase() != "ground floor") {
                                            $(".leaflet-bottom.leaflet-right").append("<div class=\"map-level-label\"><div class=\"inner-level\"></div>Level " + M.buildinglevel + "</div>");
                                        } else {
                                            $(".leaflet-bottom.leaflet-right").append("<div class=\"map-level-label\">" + M.buildinglevel + "</div>");
                                        }
                                    }
                                    map.flyTo([this._latlng.lat, this._latlng.lng], 0);
                                });
                            }

                            G.addTo(map)
                                .on("click", function (e) {
                                    L.doms.customPopup.open(this);
                                    $(".leaflet-popup-close-button").on("click", function () {
                                        $(".leaflet-interactive").attr("data-visibility", "");
                                        $(".leaflet-image-layer").attr("data-visibility", "");
                                    });
                                    if (this.options.inFilter) {
                                        // trigger filter click
                                        var mapID = this._map._container.id;
                                        var H = L.doms.findHandler(mapID);
                                        if (H.filter.container != null) {
                                            $(H.filter.container).find("[data-marker-id=" + this.options.marker_id + "]").trigger("click-on-map");
                                        }
                                        L.doms.customPopup.open(this);
                                    }
                                    // it doest work for some reason
                                    L.DomEvent.stopPropagation(e);
                                    // raise error to stop leaflet bubbling
                                    throw ("Stop the bubbling");
                                });

                            break;
                        case "polygon":
                            var options = {
                                color: M.bgcolor,
                                weight: 0,
                                fillColor: M.bgcolor,
                                fillOpacity: M.active ? M.opacity : 0.001,
                                weight: M.active ? M.borderwidth : 0,
                                title: M.title,
                                type: "polygon",
                                marker_id: marker_id,
                                active: M.active,
                                inFilter: M.infilter,
                                noClip: true,
                                stroke: M.borderwidth > 0 ? true : false,
                                smoothFactor: 0.1,

                                fillOpacityActive: M.opacity,
                                weightActive: M.borderwidth
                            };

                            var PL = L.polygon(M.points, options)
                                .on("mouseover", function (e) {
                                    this.setStyle({
                                        fillOpacity: this.options.fillOpacityActive,
                                        weight: this.options.weightActive,
                                    });
                                })
                                .on("mouseout", function (e) {
                                    this.setStyle({
                                        fillOpacity: this.options.active ? this.options.fillOpacityActive : 0.001,
                                        weight: this.options.active ? this.options.weightActive : 0
                                    });
                                })
                                .on("click", function (e) {
                                    if (this.options.inFilter) {
                                        // trigger filter click
                                        var mapID = this._map._container.id;
                                        var H = L.doms.findHandler(mapID);
                                        if (H.filter.container != null) {
                                            $(H.filter.container).find("[data-marker-id=" + this.options.marker_id + "]").trigger("click-on-map");
                                        }
                                    } else {
                                        // toggle ACTIVE status, trigger POPUP
                                        this.options.active = !this.options.active;
                                        this.fire("mouseout");
                                        if (this.options.active) {
                                            L.doms.customPopup.open(this);
                                        }
                                    }
                                    // it doest work for some reason
                                    L.DomEvent.stopPropagation(e);
                                    // raise error to stop leaflet bubbling
                                    throw ("Stop the bubbling");
                                })
                                .addTo(map);

                            return PL;
                        //EOF case 'polygon'

                        case "dotpolygon":
                            var options = {
                                color: M.bgcolor,
                                weight: 0,
                                fillColor: M.bgcolor,
                                fillOpacity: M.opacity,
                                weight: M.borderwidth,
                                title: M.title,
                                type: "polygon",
                                marker_id: marker_id,
                                active: M.active,
                                inFilter: M.infilter,
                                noClip: true,
                                stroke: M.borderwidth > 0 ? true : false,
                                smoothFactor: 0.1,
                                className: "polygon-" + M.nid,
                                fillOpacityActive: M.opacity,
                                weightActive: M.borderwidth
                            };

                            var PL = L.polygon(M.points, options)
                                .on("click", function (e) {
                                    if (this.options.inFilter) {
                                        // trigger filter click
                                        var mapID = this._map._container.id;
                                        var H = L.doms.findHandler(mapID);
                                        if (H.filter.container != null) {
                                            $(H.filter.container).find("[data-marker-id=" + this.options.marker_id + "]").trigger("click-on-map");
                                        }
                                    } else {
                                        // toggle ACTIVE status, trigger POPUP
                                        this.options.active = !this.options.active;
                                        this.fire("mouseout");
                                        if (this.options.active) {
                                            L.doms.customPopup.open(this);
                                        }
                                    }
                                    $(".map-level-label").remove();

                                    this.setStyle({
                                        fillOpacity: this.options.fillOpacityActive,
                                        weight: this.options.weightActive,
                                    });
                                    var activeClass = this.options.className;
                                    $(".leaflet-interactive").attr("data-visibility", "");
                                    $(".leaflet-interactive").attr("data-visibility", "level-invisible");
                                    $("." + activeClass).attr("data-visibility", "level-visible");
                                    $("." + M.nid).attr("data-visibility", "level-visible");
                                    // it doest work for some reason
                                    L.DomEvent.stopPropagation(e);
                                    // raise error to stop leaflet bubbling
                                    throw ("Stop the bubbling");
                                })
                                .addTo(map);

                            return PL;
                        //EOF case 'dotpolygon'

                    }
                },

                // register new map handler
                register: function (mapID, OBJ) {
                    var len = this.maps.length;
                    var F = $("#" + mapID).parent(".map-wrapper").children(".building-filter");
                    if (F.length) {

                        /* Text filter logic  */

                        // clear conrol element
                        $(F).find(".search-element .control")
                            .on("click", function (e) {
                                var I = $(F).find(".search-element input");
                                I.get(0).value = "";
                                I.trigger("change");
                            });

                        $(F).find(".mobile-control")
                            .on("click", function () {
                                $(this)
                                    .parent().children(".search-element, .list-wrapper").toggleClass("mobile-visible")
                                    .parent(".building-filter").toggleClass("mobile-active");

                                if ($("#" + mapID).parent().find(".building-filter").hasClass("mobile-active")) {
                                    //close custom-popup if any
                                    $("#" + mapID).parent().find(".custom-popup .popup-close").trigger("click");
                                }

                                //scroll to map top
                                $("html, body").animate({
                                    scrollTop: $("#" + mapID).offset().top
                                }, 250);
                            });

                        $(F).find(".search-element input")
                            .on("change", function () {
                                var value = this.value;

                                // input field state
                                if (value.length > 0) {
                                    $(this).parent().addClass("not-empty");
                                } else {
                                    $(this).parent().removeClass("not-empty");
                                }

                                if (value.length > 2 || L.doms.isNumeric(value)) {
                                    var search = value.toUpperCase().split(/\s+/);

                                    $.each($(F).find(".list .element"), function (n, elem) {
                                        var title = $(elem).find(".element-title").get(0).innerHTML.toUpperCase()
                                            + " "
                                            + $(elem).find(".element-keywords").get(0).innerHTML.toUpperCase();

                                        var found = 0;
                                        for (var k = 0; k < search.length; k++) {
                                            if (title.indexOf(search[k]) >= 0) {
                                                found++;
                                            }
                                        }

                                        if (found < search.length) {
                                            $(elem).addClass("filtered-hidden").removeClass("filtered-shown");
                                        } else {
                                            $(elem).addClass("filtered-shown").removeClass("filtered-hidden");
                                        }
                                    });
                                } else {
                                    $(F).find(".list .element, .list .group").removeClass("filtered-hidden filtered-shown");
                                }

                                // Group filtering and actions
                                if ($(F).find(".list .element.filtered-hidden").length) {
                                    var visibleGroups = 0;
                                    $.each($(F).find(".list .group"), function (i, group) {

                                        if ($(this).find(".element.filtered-shown").length == 0) {
                                            // Hide whole group
                                            $(this).addClass("filtered-hidden").removeClass("filtered-shown");
                                        } else {
                                            visibleGroups++;
                                            $(this).addClass("filtered-shown opened").removeClass("filtered-hidden closed");
                                        }
                                    });

                                    if (!visibleGroups) {
                                        $(F).find(".list .no-results").show();
                                    } else {
                                        $(F).find(".list .no-results").hide();
                                    }
                                } else {
                                    $(F).find(".list .group").removeClass("filtered-hidden filtered-shown");
                                    $(F).find(".list .no-results").hide();
                                }
                            })
                            .on("keyup", function () {
                                $(this).trigger("change");
                            });
                    }

                    this.maps[len] = {
                        id: mapID,
                        obj: OBJ,

                        /**
                         * Filter
                         */
                        filter: {
                            container: F,
                            addGroup: function (group) {
                                if (this.container !== null) {
                                    if (!$(this.container).find("[data-group-id=\"" + group.id + "\"]").length) {
                                        if (!group.title) {
                                            $(this.container).find(".list").append("\
  <div class=\"group opened" + (group.multi ? " multi" : "") + "\" data-group-id=\"" + group.id + "\">\
    <div class=\"group-content\"></div>\
  </div>");
                                        } else {
                                            $(this.container).find(".list").append("\
  <div class=\"group closed" + (group.multi ? " multi" : "") + "\" data-group-id=\"" + group.id + "\">\
    <div class=\"group-title\">" + L.doms.escapeHtml(group.title) + "</div>\
    <div class=\"group-content\"></div>\
  </div>");
                                        }
                                        $(this.container)
                                            .find("[data-group-id=\"" + group.id + "\"] .group-title")
                                            .on("click", function () {
                                                var group = $(this).parent();

                                                if (group.hasClass("closed")) {
                                                    // close other groups
                                                    $(this).parents(".list").find(".group").addClass("closed").removeClass("opened");
                                                }
                                                group.toggleClass("closed").toggleClass("opened");
                                            });
                                    }
                                }
                            },

                            /* Open given group or find parent group and open it */
                            openGroup: function (elm) {
                                if (!$(elm).hasClass("group")) {
                                    var grp = $(elm).parents(".group");
                                    if (grp.length == 0) {
                                        return false;
                                    }
                                    elm = grp.get(0);
                                }

                                if ($(elm).hasClass("closed")) {
                                    $(elm).find(".group-title").trigger("click");
                                }
                            },

                            addElement: function (elm) {
                                $(this.container).find("[data-group-id=\"" + elm.group.id + "\"] .group-content").append("\
  <div class=\"element" + (elm.active ? " active" : "") + "\" data-marker-id=\"" + elm.marker_id + "\">\
    <div class=\"element-title\" >" + L.doms.escapeHtml(elm.title) + "</div>\
    <div class=\"element-keywords\" style=\"display: none\">" + L.doms.escapeHtml(elm.keywords) + "</div>\
  </div>");
                                var T = this;
                                $(this.container).find("[data-marker-id=\"" + elm.marker_id + "\"]")
                                    .on("click", function () {
                                        T.clickElement(this, true);
                                    })
                                    .on("click-on-map", function () {
                                        T.clickElement(this, false);
                                    });
                            },

                            clickElement: function (domelm, clickInList) {
                                var marker_id = $(domelm).attr("data-marker-id");
                                var map = L.doms.getByAnyChild(domelm);
                                var mapType = map.options.data.widget;
                                var marker = map.options.data.markers[marker_id];

                                if (!clickInList) {
                                    // clear search field
                                    $(this.container).find(".search-element .control").trigger("click");
                                }

                                if (!$(domelm).hasClass("active")) {
                                    if (mapType == "retailers" || mapType == "interactive") {
                                        // update parameter show-on-map in browser URL
                                        //setUrlParameter('show-on-map', marker.title);
                                    }

                                    // activate element
                                    var group = $(domelm).parents(".group");
                                    var isMulti = group.hasClass("multi");
                                    var isPolygon = marker.type == "polygon" || marker.type == "dotpolygon";
                                    var list = group.parent();
                                    var group_id = group.attr("data-group-id");
                                    var count = 0;

                                    L.appmap_show_layer(map, marker_id);

                                    var featureGroup = L.featureGroup([]);
                                    var LR = L.doms.getLayerByMarkerID(map, marker_id);
                                    if (isPolygon) {
                                        featureGroup.addLayer(LR);
                                        count++;
                                    } else {
                                        LR.eachLayer(function (layer) {
                                            featureGroup.addLayer(layer);
                                            count++;
                                        });
                                    }

                                    $.each($(list).find(".element.active"), function (i, elm) {
                                        // hide all markers inside of other groups
                                        var it_market_id = $(elm).attr("data-marker-id");
                                        var it_LR = L.doms.getLayerByMarkerID(map, it_market_id);
                                        var it_group = $(elm).parents(".group");
                                        var it_group_id = $(it_group).attr("data-group-id");

                                        if (group_id != it_group_id || !isMulti) {
                                            // deactivate other group items
                                            $(elm).trigger("click-on-map");
                                        } else {
                                            if (!L.doms.isMobile()) {
                                                if (map.options.data.markers[it_market_id].type == "polygon" || map.options.data.markers[it_market_id].type == "dotpolygon") {
                                                    featureGroup.addLayer(it_LR);
                                                    count++;
                                                } else {
                                                    it_LR.eachLayer(function (layer) {
                                                        featureGroup.addLayer(layer);
                                                        count++;
                                                    });
                                                }
                                            }
                                        }
                                    });

                                    if (mapType != "retailers") {
                                        L.doms.customPopup.open(LR);
                                    }

                                    // Show details for retailers
                                    var detailsIsShown = false;
                                    if (mapType == "retailers") {
                                        var H = L.doms.findHandler(map._container.id);
                                        if (H.filter.container != null) {
                                            var details = $(H.filter.container).find(".details-wrapper");
                                            if (marker.popup.content) {
                                                details.find(".details-content").html(marker.popup.content);
                                                details.addClass("active");
                                                var T = this;
                                                details.find(".details-close").off("click").click(function () {
                                                    //clickElement
                                                    T.clickElement(domelm, true);
                                                });
                                                detailsIsShown = true;
                                            } else {
                                                details.removeClass("active");
                                            }
                                        }
                                    }

                                    if (clickInList || detailsIsShown) {
                                        if (marker.type == "dot") {
                                            $(this).trigger("click");
                                            $(".leaflet-interactive").attr("data-visibility", "");
                                            $(".leaflet-interactive").attr("data-visibility", "level-invisible");
                                            $(".leaflet-image-layer").attr("data-visibility", "level-invisible");
                                            $("." + marker.buildinglevel + "-level").attr("data-visibility", "level-visible");
                                            $(".map-level-label").remove();
                                            if (marker.buildinglevel !== null) {
                                                if (String(marker.buildinglevel).toLowerCase() != "ground floor") {
                                                    $(".leaflet-bottom.leaflet-right").append("<div class=\"map-level-label\"><div class=\"inner-level\"></div>Level " + marker.buildinglevel + "</div>");
                                                } else {
                                                    $("." + marker.buildinglevel.replace(" ", "-").toLowerCase() + "-level").attr("data-visibility", "level-visible");
                                                    $(".leaflet-bottom.leaflet-right").append("<div class=\"map-level-label\">" + marker.buildinglevel + "</div>");
                                                }
                                            }
                                        } else if (marker.type == "dotpolygon") {
                                            $(".polygon-" + marker.nid).trigger("click");
                                            $(".leaflet-interactive").attr("data-visibility", "");
                                            $(".leaflet-interactive").attr("data-visibility", "level-invisible");
                                            $(".polygon-" + marker.nid).attr("data-visibility", "level-visible");
                                            $("." + marker.nid).attr("data-visibility", "level-visible");
                                        }
                                        // pan to active item/group
                                        if (count == 1 && map.options.data.maxPanSize.w > 0) {
                                            // for one object panning uses consistent size of viewed area
                                            var PS = map.options.data.maxPanSize;
                                            var BND = featureGroup.getBounds();
                                            var CENTER = BND.getCenter();

                                            if (mapType == "retailers" && marker.popup.content) {
                                                var objW = Math.max(BND.getEast() - BND.getWest(), map.options.data.w / 10);
                                                var objH = Math.max(BND.getNorth() - BND.getSouth(), map.options.data.h / 10);

                                                var PL = L.polyline([
                                                    [L.latLng(CENTER.lat - objW * 1, CENTER.lng - objH * 2.5)],
                                                    [L.latLng(CENTER.lat + objW * 1, CENTER.lng + objH * 1)]
                                                ]);
                                                map.flyToBounds(PL.getBounds());
                                            } else {
                                                var PL = L.polyline([
                                                    [L.latLng(CENTER.lat - PS.w / 2, CENTER.lng - PS.h / 2)],
                                                    [L.latLng(CENTER.lat + PS.w / 2, CENTER.lng + PS.h / 2)]
                                                ]);
                                                map.flyToBounds(PL.getBounds(), { padding: [40, 50] });
                                            }
                                        } else {
                                            // pan using bounds of 2 or more selected objects
                                            map.flyToBounds(featureGroup.getBounds(), { maxZoom: 1 });
                                        }

                                        // close filter on mobile
                                        if (!isMulti && L.doms.isMobile()) {
                                            $(this.container).find(".mobile-control").trigger("click");
                                        }

                                    } else {
                                        // open element group
                                        $(domelm).parents(".group.closed").children(".group-title").trigger("click");
                                    }

                                } else {
                                    var LR = L.doms.getLayerByMarkerID(map, marker_id);
                                    L.doms.customPopup.close(LR);
                                    L.appmap_hide_layer(map, marker_id);

                                    // Hide details for retailers
                                    if (mapType == "retailers") {
                                        var H = L.doms.findHandler(map._container.id);
                                        if (H.filter.container != null) {
                                            var details = $(H.filter.container).find(".details-wrapper");
                                            details.removeClass("active");
                                            details.find(".details-content").html("");
                                        }
                                    }
                                }

                                $(domelm).toggleClass("active");

                                if (clickInList && $(this.container).find(".element.active").length == 0 && mapType != "retailers") {
                                    map.flyTo([map.options.data.h / 2, map.options.data.w / 2], map.options.data.zoom);
                                }
                            }
                        },

                    };
                    if (OBJ.options.data !== undefined) {
                        OBJ.options.data.handler_id = len;
                    }
                    return len;
                },

                // some service functions
                isNumeric: function (n) {
                    return !isNaN(parseFloat(n)) && isFinite(n);
                },

                escapeHtml: function (text) {
                    return text
                        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                },

            }
        });

        $(window).resize(function () {
            if (L.doms.isMobile()) {

                // find and forse activate first trail marker on mobile if no markers are active
                $(".map-trail").each(function (index, value) {
                    var active = $(value).find(".list-wrapper .list .item.active");

                    if (!active.length) {
                        var mapCandidate = $(value).find(".node-map");
                        if (mapCandidate.length > 0) {
                            var map = L.doms.getByAnyChild(mapCandidate.get(0));
                            // activate first trail point
                            if (map.options.data.widget == "trail") {
                                L.doms.setActiveTrail(map, 0, 0);
                            }
                        }
                    }
                });
            }
        });

        // leaflet is loaded event definition
    });

    if (typeof (L.latLng) != "undefined") {
        $(document).trigger("leafletIsLoaded");
    }

})(jQuery);
let loadMorePost
if (typeof archive_main_query !== "undefined") {
    loadMorePost = {
        currentRequest: null,
        resultBlock: "",
        loadMoreBtn: jQuery('.load-more-ajax'),
        loadMoreBtnDefaultText: "See More",
        isDataAvailable: true,
        executing: false,
        data: {
            action: "mp_loadmore",
            query: archive_main_query.posts,
            page: parseInt(archive_main_query.current_page),
            taxonomy: "",
            taxonomy_type: "",
            search: "",
            latest: "",
            sortby: "",
        },
        execute_ajax: function () {
            let _ = this;
            _.currentRequest = jQuery.ajax({
                type: "post",
                url: archive_main_query.ajaxurl,
                data: _.data,
                dataType: "json",
                beforeSend: function () {
                    if (_.currentRequest !== null) {
                        _.currentRequest.abort();
                    }
                    if (_.loadMoreBtn) {
                        _.loadMoreBtn.html("<span>Loading...</span>");
                    }
                },
                success: function (response) {
                    if (_.data.page == 0) {
                        _.resultBlock.html(response.result);
                    } else {
                        _.resultBlock.append(response.result);
                    }
                    if (_.loadMoreBtn) {
                        _.loadMoreBtn.show();
                        _.isDataAvailable = true;
                        if (!response.more_data) {
                            _.loadMoreBtn.hide();
                            _.isDataAvailable = false;
                        }
                        _.loadMoreBtn.html(_.loadMoreBtnDefaultText);
                        _.executing = false;
                    }
                }
            });
        }
    };
}

jQuery(".load-more-ajax").click(function () {
    loadMorePost.executing = true;
    loadMorePost.data.page = parseInt(loadMorePost.data.page) + 1;
    loadMorePost.loadMoreBtn = jQuery(this);
    loadMorePost.resultBlock = jQuery('.ajax-response');
    loadMorePost.loadMoreBtnDefaultText = loadMorePost.loadMoreBtn.html();
    loadMorePost.execute_ajax();
});

jQuery(".load-more-latest-ajax").click(function () {
    var number = parseInt(jQuery(this)[0].dataset.page);
    loadMorePost.executing = true;
    loadMorePost.data.query = JSON.stringify(jQuery(this).data("query"));
    loadMorePost.data.page = number;
    loadMorePost.loadMoreBtn = jQuery(this);
    loadMorePost.data.latest = 'yes';
    loadMorePost.resultBlock = jQuery('.ajax-response-latest');
    loadMorePost.loadMoreBtnDefaultText = loadMorePost.loadMoreBtn.html();
    $(this).attr("data-page", (number + 1));
    loadMorePost.execute_ajax();
});

jQuery(".offer__cat").on("click", function () {
    jQuery(".filter .main__btn.main__btn--alt--active").removeClass("main__btn--alt--active");
    jQuery(this).addClass("main__btn--alt--active");
    loadMorePost.data.page = "0";
    loadMorePost.data.taxonomy_type = "offer_type";
    loadMorePost.data.taxonomy = jQuery(this).data("catid");
    loadMorePost.resultBlock = jQuery(".ajax-response");
    loadMorePost.execute_ajax();
});


if (jQuery("body").hasClass("post-type-archive-eatdrinkshop") || jQuery("body").hasClass("tax-retailer_category")) {
    jQuery('#search__form').submit(function (e) {
        e.preventDefault();
        loadMorePost.executing = true;
        loadMorePost.data.page = "0";
        loadMorePost.data.taxonomy_type = "retailer_tags";
        loadMorePost.data.taxonomy = '';
        loadMorePost.data.search = jQuery('#edit-search').val();
        loadMorePost.resultBlock = jQuery(".ajax-response");
        loadMorePost.execute_ajax();
    })

    $('.archive__chars__list__item a').on('click', function (e) {
        e.preventDefault();
        var sortby = $(this).attr('href').split('=')[1];
        $('.archive__chars__list__item').removeClass('archive__chars__list__item--active');
        $(this).parent().addClass('archive__chars__list__item--active');
        if (sortby) {
            jQuery('#edit-search').val('');
            loadMorePost.executing = true;
            loadMorePost.data.page = "0";
            loadMorePost.data.sortby = sortby;
            loadMorePost.data.search = '';
            loadMorePost.resultBlock = $(".ajax-response");
            loadMorePost.execute_ajax();
            jQuery(window).scroll(function (e) {
                if (loadMorePost.executing == false && loadMorePost.isDataAvailable == true) {
                    if (jQuery(window).scrollTop() >= (jQuery(document).height() - jQuery(window).height() - jQuery('footer').height())) {
                        jQuery(".infinite-scroll .load-more-ajax").trigger('click');
                    }
                }
            });
        }
    });
}

jQuery('#search__jobs').submit(function (e) {
    e.preventDefault();
    loadMorePost.executing = true;
    loadMorePost.data.page = "0";
    loadMorePost.data.taxonomy_type = '';
    loadMorePost.data.taxonomy = '';
    loadMorePost.data.search = jQuery('#job-search').val();
    loadMorePost.resultBlock = jQuery(".ajax-response");
    loadMorePost.execute_ajax();
});

jQuery(".whats_on__tags").on("click", function () {
    var url = jQuery(this).data("slug");
    window.location.href = url;
});

if (jQuery("body").hasClass("post-type-archive-eatdrinkshop") || jQuery("body").hasClass("tax-retailer_category") || jQuery("body").hasClass("tax-retailer_tags") || jQuery("body").hasClass("tax-retailer_location")) {
    var search = getParameterByName('search');
    var sortby = getParameterByName('sortby');
    if (search || sortby) {
        loadMorePost.executing = true;
        loadMorePost.data.page = "0";
        if (sortby) {
            loadMorePost.data.sortby = sortby;
        } else {
            loadMorePost.data.sortby = '';
            loadMorePost.data.search = search;
        }
        loadMorePost.resultBlock = jQuery(".ajax-response");
        loadMorePost.execute_ajax();
    }
    jQuery(window).scroll(function (e) {
        if (loadMorePost.executing == false && loadMorePost.isDataAvailable == true) {
            if (jQuery(window).scrollTop() >= (jQuery(document).height() - jQuery(window).height() - jQuery('footer').height())) {
                jQuery(".infinite-scroll .load-more-ajax").trigger('click');
            }
        }
    });
}

if (jQuery("body").hasClass("post-type-archive-jobs")) {
    jQuery(window).scroll(function (e) {
        if (jQuery('.promo__item__cont').length >= 10) {
            if (loadMorePost.executing == false && loadMorePost.isDataAvailable == true) {
                if (jQuery(window).scrollTop() >= (jQuery(document).height() - jQuery(window).height() - jQuery('footer').height())) {
                    jQuery(".infinite-scroll .load-more-ajax").trigger('click');
                }
            }
        }
    });
}

if (jQuery("body").hasClass("post-type-archive-facilities")) {
    var facility_category = getParameterByName('facility_category');
    if (facility_category) {
        jQuery(".side-filter__body").find('.side-filter__item--active').removeClass('side-filter__item--active');
        jQuery('[data-catname="' + facility_category + '"]').trigger('click').addClass('side-filter__item--active');
    }
}

function appmap_init_1313() {
    var post_id = $('.node-map').data("id");
    jQuery.ajax({
        type: "post",
        dataType: "json",
        url: archive_main_query.ajaxurl,
        data: { action: 'get_map_init', post_id: post_id },
        success: function (markers) {
            if (document.querySelector(".node-map")) {
                appmap_init('node-1313', markers)
            }
        }
    });
}
jQuery(document).on('leafletIsReady', function (e) {
    if (document.querySelector(".node-map")) {
        appmap_init_1313();
    }
});
if (typeof (L.latLng) != 'undefined') {
    jQuery(document).trigger('leafletIsReady');
}

import autocomplete from "devbridge-autocomplete";
autocomplete
jQuery('#edit-search').autocomplete({
    lookup: function (query, done) {
        jQuery.ajax({
            type: "post",
            url: archive_main_query.ajaxurl,
            data: {
                action: "autocomplete_search",
                search: jQuery('#edit-search').val(),
                retailer_category: jQuery('#retailer_category').val(),
            },
            dataType: "json",
            success: function (response) {
                done(response);
            }
        });
    },
    appendTo: ".archive__banner__item__search__form",
    noCache: true,
    width: "100%",
    triggerSelectOnValidInput: false,
    onSelect: function (suggestion) {
        if (suggestion.data) {
            loadMorePost.executing = true;
            loadMorePost.data.page = "0";
            jQuery('input[name="type"]').val(suggestion.type);
            loadMorePost.data.sortby = '';
            loadMorePost.data.search = suggestion.value;
            loadMorePost.resultBlock = jQuery(".ajax-response");
            loadMorePost.execute_ajax();
            if (jQuery("body").hasClass("single-eatdrinkshop")) {
                jQuery('#search__form').submit();
            }
        }
    }
});

jQuery('#job-search').autocomplete({
    lookup: function (query, done) {
        jQuery.ajax({
            type: "post",
            url: archive_main_query.ajaxurl,
            data: {
                action: "autocomplete_search_job",
                search: jQuery('#job-search').val(),
            },
            dataType: "json",
            success: function (response) {
                done(response);
            }
        });
    },
    appendTo: ".search__form",
    noCache: true,
    width: "100%",
    triggerSelectOnValidInput: false,
    onSelect: function (suggestion) {
        if (suggestion.label.length) {
            location.href = suggestion.label;
        } else {
            jQuery('#job-search').val('');
            return false;
        }
    }
});

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

; (function ($) {
    $.fn.extend({
        donetyping: function (callback, timeout) {
            timeout = timeout || 1e3; // 1 second default timeout
            var timeoutReference,
                doneTyping = function (el) {
                    if (!timeoutReference) return;
                    timeoutReference = null;
                    callback.call(el);
                };
            return this.each(function (i, el) {
                var $el = $(el);
                $el.is(':input') && $el.on('keyup keypress paste', function (e) {
                    // This catches the backspace button in chrome, but also prevents
                    // the event from triggering too preemptively. Without this line,
                    // using tab/shift+tab will make the focused element fire the callback.
                    if (e.type == 'keyup' && e.keyCode != 8) return;
                    // Check if timeout has been set. If it has, "reset" the clock and
                    // start over again.
                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function () {
                        // if we made it here, our timeout has elapsed. Fire the
                        // callback
                        doneTyping(el);
                    }, timeout);
                }).on('blur', function () {
                    // If we can, fire the event since we're leaving the field
                    doneTyping(el);
                });
            });
        }
    });
})(jQuery);

jQuery(document).ready(function () {
    let searchPost = {
        resultBlock: "",
        data: {
            action: "mp_search",
            posttype: "",
            search: "",
            taxonomy: "",
        },
        execute_ajax: function () {
            let _ = this;
            jQuery.ajax({
                type: "post",
                url: archive_main_query.ajaxurl,
                data: _.data,
                dataType: "json",
                beforeSend: function () {
                    jQuery(".loader").show();
                    jQuery(".filter-close").hide();
                },
                success: function (response) {
                    jQuery(".loader").hide();
                    if(_.data.search){
                        jQuery(".filter-close").show();
                    }else{
                        jQuery(".filter-close").hide();
                    }
                    _.resultBlock.html(response.result)
                    let accordions = document.querySelectorAll('.accordion__item__head');
                    let expandAll = document.querySelector(".accordion__expand-all")
                    initAccordionClicks(accordions, expandAll);
                }
            });
        }
    };

    jQuery("#faq_search").donetyping(function () {
        searchPost.data.search = jQuery(this).val();
        searchPost.resultBlock = jQuery(".faq_content");
        searchPost.data.posttype = "faqs";
        searchPost.execute_ajax();
    });

    jQuery("#facilities_search").donetyping(function () {
        searchPost.data.search = jQuery(this).val();
        searchPost.resultBlock = jQuery(".facilities_content");
        searchPost.data.posttype = "facilities";
        searchPost.execute_ajax();
    });

    jQuery('.facilities__cat').on('click', function () {
        jQuery(".side-filter__body").find('.side-filter__item--active').removeClass('side-filter__item--active');
        jQuery(this).addClass('side-filter__item--active');
        searchPost.data.taxonomy = jQuery(this).data().catid;
        searchPost.resultBlock = jQuery(".facilities_content");
        searchPost.data.posttype = "facilities";
        searchPost.execute_ajax();
    });

    jQuery('.filter-close').on('click', function () {
        jQuery(this).parents('.filter-content__content__search').find('.form__input').val('').keypress();
    });
});

let loadOfficeFilter
loadOfficeFilter = {
        resultBlock: "",
        resultsholder: jQuery('.spaces__grid'),
        countholder: jQuery('.spaces__filters__num__display'),
        data: {
            action: "filter_offices",
            off_category: "",
        },
        execute_ajax: function () {
            let _ = this;
            _.currentRequest = jQuery.ajax({
                type: "post",
                url: archive_main_query.ajaxurl,
                data: _.data,
                dataType: "html",
                success: function (response) {
                    var results = response.split("%", 2)
                  _.resultsholder.html(results[0]);
                  _.countholder.html(results[1]);

                }
                });
            }
        };



        jQuery(".spaces__filters__btns__item").click(function () {
          jQuery(".spaces__filters__btns__item").removeClass("spaces__filters__btns__item--active");
          jQuery(this).addClass("spaces__filters__btns__item--active");
          loadOfficeFilter.data.off_category = jQuery(this).data("slug");
          loadOfficeFilter.execute_ajax();       
      });



      let loadMoreOffers
    loadMoreOffers = {
        currentRequest: null,
        resultBlock: "",
        loadMoreBtn: jQuery('.load-more-ajax'),
        loadMoreBtnDefaultText: "See More",
        isDataAvailable: true,
        executing: false,
        data: {
            action: "mp_loadmore",
            query: archive_main_query.posts,
            page: parseInt(archive_main_query.current_page),
            taxonomy: "",
            taxonomy_type: "offer_type",
            search: "",
            latest: "",
        },
        execute_ajax: function () {
            let _ = this;
            _.currentRequest = jQuery.ajax({
                type: "post",
                url: archive_main_query.ajaxurl,
                data: _.data,
                dataType: "json",
                beforeSend: function () {
                    if (_.currentRequest !== null) {
                        _.currentRequest.abort();
                    }
                    if (_.loadMoreBtn) {
                        _.loadMoreBtn.html("<span>Loading...</span>");
                    }
                },
                success: function (response) {
                    if (_.data.page == 0) {
                        _.resultBlock.html(response.result);
                    } else {
                        _.resultBlock.append(response.result);
                    }
                    if (_.loadMoreBtn) {
                        _.loadMoreBtn.show();
                        _.isDataAvailable = true;
                        if (!response.more_data) {
                            _.loadMoreBtn.hide();
                            _.isDataAvailable = false;
                        }
                        _.loadMoreBtn.html(_.loadMoreBtnDefaultText);
                        _.executing = false;
                    }
                }
            });
        }
    };

jQuery(".offers-section-load-more-ajax").click(function () {
    loadMoreOffers.executing = true;
    loadMoreOffers.data.taxonomy = jQuery(this).data("type");
    loadMoreOffers.data.page = parseInt(loadMoreOffers.data.page) + 1;
    loadMoreOffers.loadMoreBtn = jQuery(this);
    loadMoreOffers.resultBlock = jQuery('.ajax-response');
    loadMoreOffers.loadMoreBtnDefaultText = loadMoreOffers.loadMoreBtn.html();
    loadMoreOffers.execute_ajax();
});



let disclaimer
disclaimer = {
        data: {
            action: "disclaimer",
            href: "",
        },
        execute_ajax: function () {
            let _ = this;
            _.currentRequest = jQuery.ajax({
                type: "post",
                url: archive_main_query.ajaxurl,
                data: _.data,
                cache: false,
                dataType: "json",
                success: function (response) {
                    console.log(response.disclaimer)
                    window.location.href=window.location.href
                }
                });
            }
        };



jQuery(".disclaimerAccept").click(function (e) {
    e.preventDefault();
    disclaimer.href = $(this).attr('href');
    disclaimer.execute_ajax();
});
// Remove hover states from css if touchscreen
if("ontouchstart" in document.documentElement
    || navigator.maxTouchPoints > 0
    || navigator.msMaxTouchPoints > 0){
    try{
        for(let si in document.styleSheets){
            var styleSheet = document.styleSheets[si];
            if(!styleSheet.rules)continue;

            for(let ri = styleSheet.rules.length - 1; ri >= 0; ri--){
                if(!styleSheet.rules[ri].selectorText)continue;

                if(styleSheet.rules[ri].selectorText.match(":hover")){
                    styleSheet.deleteRule(ri);
                }
            }
        }
    }catch(ex){ }
}

function initDetail(){
    let details = document.querySelectorAll(".detail");

    if(details.length > 0){
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        details.forEach(detail => {
            let headBtns = detail.querySelectorAll(".detail__head__btn");

            for(let i = 0; i < headBtns.length; i++){
                headBtns[i].addEventListener("click", function (){
                    detail.querySelector(".detail__head__btn--active").classList.remove("detail__head__btn--active");
                    headBtns[i].classList.add("detail__head__btn--active");

                    detail.querySelector(".detail__body__item--active").classList.remove("detail__body__item--active");
                    detail.querySelectorAll(".detail__body__item")[i].classList.add("detail__body__item--active");
                });
            }

            if(params.showPane){
                if(params.showPane === "offers"){
                    detail.querySelector(".detail__head__btn--active").classList.remove("detail__head__btn--active");
                    headBtns[1].classList.add("detail__head__btn--active");

                    detail.querySelector(".detail__body__item--active").classList.remove("detail__body__item--active");
                    detail.querySelectorAll(".detail__body__item")[1].classList.add("detail__body__item--active");
                }
            }
        });
    }
}

function initPopups(){
    const popups = document.querySelectorAll(".popup__wrap");

    popups.forEach(popup => {
        const closePopup = popup.querySelector(".popup__wrap__close");

        if(closePopup){
            closePopup.addEventListener("click", function (){
                popup.classList.remove("popup__wrap--open");
                window.localStorage.setItem("auto_popup__close", true);
                scroller.paused(false);
            });
        }

        const link = popup.querySelector(".popup__wrap a");

        if(link){
            link.addEventListener("click", function (){
                window.localStorage.setItem("auto_popup__close", true);
            });
        }

        document.addEventListener("keydown", (event) => {
            if(event.key === "Escape"){
                const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
                if(isNotCombinedKey){
                    popup.classList.remove("popup__wrap--open");
                    scroller.paused(false);
                }
            }
        });

        if(!window.localStorage.getItem("auto_popup__close")){
            if(popup.id === "autoOpen") popup.classList.add("popup__wrap--open");
        }
    });

    const popupTriggers = document.querySelectorAll(".popup__trigger");
    popupTriggers.forEach(popupTrigger => {
        popupTrigger.addEventListener("click", function (e){
            e.preventDefault();

            const popup = document.querySelector(`.popup__wrap#${popupTrigger.dataset.popup_id}`);
            popup?.classList.add("popup__wrap--open");

            scroller.paused(true);
            document.querySelector(".header--fixed").classList.remove("header--fixed--down");
        });
    });
}

function initWalkthrough(){
    let walkthroughs = document.querySelectorAll(".walkthrough");

    if(walkthroughs.length > 0){
        let walkthroughPopup = document.querySelector(".walkthrough__popup");

        walkthroughs.forEach(walkthrough => {
            walkthrough.querySelector(".walkthrough__inner__open").addEventListener("click", function (e){
                walkthroughPopup.querySelector("iframe").src = e.target.dataset.src;

                walkthroughPopup.classList.add("walkthrough__popup--open");
                scroller.paused(true);
                document.querySelector(".header--fixed").classList.remove("header--fixed--down");
            });
        });

        document.querySelector(".walkthrough__popup__close").addEventListener("click", function (){
            walkthroughPopup.classList.remove("walkthrough__popup--open");
            scroller.paused(false);
        });

        document.addEventListener("keydown", (event) => {
            if(event.key === "Escape"){
                //if esc key was not pressed in combination with ctrl or alt or shift
                const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
                if(isNotCombinedKey){
                    walkthroughPopup.classList.remove("walkthrough__popup--open");
                    scroller.paused(false);
                }
            }
        });
    }
}

function initShowtimes(){
    const showtimes = document.querySelectorAll(".showtimes-open");
    showtimes.forEach(el => {
        el.addEventListener("click", function (){
            el.classList.toggle("showtimes-open--active");
            el.parentElement.parentElement.querySelector(".showtimes").classList.toggle("showtimes--active");
        });
    });
}

import"select2";
function initCustomSelect(){
    let selects = document.querySelectorAll(".custom-select");

    selects.forEach(select => {
        const mySelect2 = $(select).select2({
            default: true,
            allowClear: false,
            closeOnSelect: false,
            tags: false,
            placeholder: {
                id: "0", // the value of the option
                text: "All employers"
            },
            dropdownParent: $(select).parent(),

            templateSelection: function (data, container){
                // If the element is not a tag (it is the select box), then return the selection
                if(data.id === undefined)return data.text;

                var selectedOptions = $(data.element).parent().find(":selected");
                if(selectedOptions.length > 1){
                    return selectedOptions.length + " employers";

                }else return data.text;  // Return the text if only one selected
            }
        });

        mySelect2.on("change", function (e){
            var selected = $(this).val();

            if(selected.includes("all")){
                $(this).val(null).trigger("change");
                mySelect2.select2("close");
            }
        });
    });

    $(".custom-select").on("select2:opening", function (event){
        $("#search__apply").addClass("search__apply--show");
    });

    $(".custom-select").on("select2:closing", function (event){
        setTimeout(() => {
            $("#search__apply").removeClass("search__apply--show");
        }, 1000);
    });

    $(".custom-select").on("select2:opening select2:closing", function (event){
        var $searchfield = $(this).parent().find(".select2-search__field");
        $searchfield.prop("disabled", true);
    });
}

function initEalingHomePromo(){
    if(window.location.href.includes("ealing")){
        const promo = document.querySelector("body.home .promo");

        if(promo){
            const wrapper = document.createElement("div");
            wrapper.setAttribute("class", "promo__wrap");

            promo.parentNode.insertBefore(wrapper, promo);
            wrapper.appendChild(promo);

            promo.classList.remove("fade-el");

            gsap.fromTo(wrapper, { opacity: 0, y: 25 }, {
                opacity: 1,
                y: 0,
                ease: "ease",
                duration: 1.4,

                scrollTrigger: {
                    trigger: wrapper,
                    start: "top bottom-=5%",
                    end: "bottom top",
                }
            });
        }
    }
}

function initWpcf7Redirect(){
    const forms = document.querySelectorAll("#wpcf7-f10857-o2, #wpcf7-f9639-o2, #wpcf7-f2011-o1, #wpcf7-f2510-o1, #wpcf7-f19083-o2, #wpcf7-f50860-o2, #wpcf7-f33008-o2, #wpcf7-f2547-o1, #wpcf7-f2049-o1");
    let urlParams = new URLSearchParams(window.location.search);

    forms.forEach(form => {
        form.addEventListener("wpcf7submit", function(event){
            window.location.replace("https://" + window.location.hostname + "/thank-you" + '?' + urlParams.toString());
        }, false);
    });
}


function storeUTMs() {
    if (window.location.search.includes('utm_')) {
        document.addEventListener('click', function(event){
            let aTag = (event.target as HTMLElement).closest('a');

            if (aTag !== null) {
                const urlParams = new URLSearchParams(window.location.search);
                let aParams = new URLSearchParams(aTag.search);
    
                for (let [key, value] of urlParams.entries()) {
                    if (! aParams.has(key) && key.includes('utm_')) {
                        aParams.append(key, value);
                    }
                }

                aTag.href = aTag.href.split('?')[0] + '?' + aParams.toString();
            }
        });
    }

    const formUrlField = document.querySelector('input[name="formurl"]');
    const currentPageUrl = window.location.href;
    if (formUrlField) formUrlField.setAttribute('value', currentPageUrl);
}
(function ($){
    $(document).bind("leafletIsReady", function (e){
        // select new map source
        var sel = $("#edit-field-mp-map-und")
            .change(function (){
                appmap_change(this);
            })
            .attr("data-map", "nodemap")
            .trigger("change");
    });
})(jQuery);

function appmap_change(th){
    var value = th.value;
    // request map data
    jQuery.ajax({
        url: "/admin/ajaxmap/get/" + value,
        dataType: "json",
        success: function (data, textStatus, jqXHR){
            if(data.error.code){
                console.log(data.error.text);
            }else{
                appmap_mapinit(jQuery(th).attr("data-map"), data.map);
            }
        },
        error: function (jqXHR, textStatus, errorThrown){
            alert(textStatus);
        },
    });
}

/**
 * Init / reinit map
 */
function appmap_mapinit(map_id, data){
    var map = L.doms.get(map_id);
    var w = data.w;
    var h = data.h;
    var sw = document.body.clientWidth;
    var sh = document.body.clientHeight;

    var bounds = [[0, 0], [(h + sh) / 2, (sw + w) / 2]];
    var ibounds = L.latLngBounds(L.latLng(0, 0), L.latLng(h, w));

    if(map == null){
        map = L.map(map_id, {
            crs: L.CRS.Simple,
            maxBounds: ibounds,
            minZoom: -2,
            maxZoom: 10,
            zoom: 0
        }).on("click", function (e){
            appmap_addmarker(map, e.latlng, 1);
        });
        L.doms.register(map_id, map);
    }else{
        L.appmap_remove_layers(map, "BG");
    }

    // Add BG layers
    for(var k = 0; k < data.urls.length; k++){
        var LR = L.imageOverlay(data.urls[k], ibounds).addTo(map);
        LR.options.title = "BG";
    }
    // Add markers
    appmap_draw(map);

    map.panTo([h / 2, w / 2]);
    //map.fitBounds(bounds);

}

/**
 * Save coords to data_holder field
 */
function appmap_savecoods(map){
    var dots = [];
    var h = map.options.maxBounds._northEast.lat;
    var w = map.options.maxBounds._northEast.lng;

    map.eachLayer(function (layer){
        if(layer.options.title == "Marker"){
            var P = layer.getLatLng();
            dots.push({ h: P.lat / h, w: P.lng / w });
        }
    });

    var geodata = jQuery("#edit-field-mp-data-und-0-value").get(0);
    geodata.value = JSON.stringify(dots);
    return dots;
}

/**
 * Draw markers set
 */
function appmap_draw(map){
    console.log("DRAW");
    var h = map.options.maxBounds._northEast.lat;
    var w = map.options.maxBounds._northEast.lng;
    console.log(w + " x " + h);
    L.appmap_remove_layers(map, "Marker");

    try{
        var geodata = jQuery("#edit-field-mp-data-und-0-value").get(0).value;
        var dots = JSON.parse(geodata);
    }catch(err){
        var dots = [];
    }

    for(var k = 0; k < dots.length; k++){
        var latlng = L.latLng(dots[k].h * h, dots[k].w * w);
        appmap_addmarker(map, latlng, 0);
    }

}

/**
 * Place new marker
 */
function appmap_addmarker(map, latlng, andSave){

    var count = 0;
    map.eachLayer(function (layer){
        if(layer.options.title == "Marker"){
            count++;
        }
    });

    // only one point need
    if(count > 0){
        return;
    }

    var marker = L.marker(latlng, {
        draggable: true,
        title: "Marker",
    })
        .on("click", function (){
            marker.remove();
            appmap_savecoods(map);
        })
        .on("dragend", function (e){
            appmap_savecoods(map);
        });
    marker.addTo(map);

    if(andSave){
        appmap_savecoods(map);
        var map = L.doms.get("nodemap");
        appmap_draw(map);
    }

}



/* Extract get parameter from current URL */
var getUrlParameter = function getUrlParameter(sParam){
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

    for(i = 0; i < sURLVariables.length; i++){
        sParameterName = sURLVariables[i].split("=");

        if(sParameterName[0] === sParam){
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

/* Set parameter of current URL */
var setUrlParameter = function setUrlParameter(sParam, newValue){
    var url = new urlManagerClass(window.location.toString());
    url.setUrlParameter(sParam, newValue);
    history.replaceState({}, "", url.getUrl());
    return url.getUrl();
};

/* Extract chunk from page URL path */
var getUrlChunk = function getUrlChunk(i){
    var chunks = window.location.pathname.split("/");
    return chunks[i] !== undefined ? chunks[i] : false;
};

/* Updates chunk of page URL path, returns newURL string */
var setUrlChunk = function setUrlChunk(i, value){
    var url = new urlManagerClass(window.location.toString());
    url.setUrlChunk(i, value);
    history.replaceState({}, "", url.getUrl());
    return url.getUrl();
};

/* Utility class implements additional manipulations with URLs */
function urlManagerClass(urlString){
    var url = new URL(urlString);

    this.getUrl = function (){
        return url.toString();
    };

    /* Extract get parameter from given URL */
    this.getUrlParameter = function (sParam){
        var sPageURL = url.search.substring(1),
            sURLVariables = sPageURL.split("&"),
            sParameterName,
            i;

        for(i = 0; i < sURLVariables.length; i++){
            sParameterName = sURLVariables[i].split("=");

            if(sParameterName[0] === sParam){
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    this.setUrlParameter = function (sParam, newValue){
        var sPageURL = url.search.substring(1),
            sURLVariables = sPageURL.split("&"),
            sParameterName,
            i,
            newLocation = "",
            found = false;

        for(i = 0; i < sURLVariables.length; i++){
            sParameterName = sURLVariables[i].split("=");
            if(sParameterName[0] === sParam && newValue === null){
                continue;
            }
            if(newLocation !== ""){
                newLocation += "&";
            }
            if(sParameterName[0] === sParam){
                newLocation += sParameterName[0] + "=" + encodeURIComponent(newValue);
                found = true;
            }else{
                newLocation += sURLVariables[i];
            }
        }

        if(!found && newValue !== null){
            newLocation += (newLocation === "" ? "" : "&") + sParam + "=" + encodeURIComponent(newValue);
        }
        url.search = (newLocation === "" ? "" : "?" + newLocation);
        return this;
    };

    this.setUrlChunk = function (i, value){
        var chunks = url.pathname.split("/");
        for(var j = 0; j <= i; j++){
            if(chunks[j] == undefined){
                chunks[j] = "-";
            }
            if(j == i){
                chunks[j] = value.replace(" ", "-");
            }
        }

        url.pathname = chunks.join("/").toLowerCase();
        return this;
    };

    this.setHistoryMark = function (){
        history.replaceState({}, "", this.getUrl());
        return this;
    };

}
function initPromo(){
    let promoCardVideos = document.querySelectorAll(".promo__item__img > video");
    promoCardVideos.forEach(video => {
        video.parentElement.classList.add("promo__item__img__video");

        video.parentElement.parentElement.addEventListener("mouseenter", function (){
            video.play();
        });

        video.parentElement.parentElement.addEventListener("mouseleave", function (){
            video.pause();
        });
    });

    let promoSocials = document.querySelectorAll(".promo--social .promo__item");
    promoSocials.forEach(item => {
        item.addEventListener("click", function (){
            item.classList.toggle("promo__item--active");
        });
    });

    let promo = document.querySelectorAll(".promo");
    promo.forEach(el => {
        let items = el.querySelectorAll(".promo__item");
        for(let i = 0; i < items.length; i++){
            const item = items[i];

            gsap.fromTo(item.querySelector(".promo__item__inner"), { opacity: 0 }, {
                opacity: 1,

                scrollTrigger: {
                    trigger: el,
                    scrub: false,
                    start: "top bottom-=5%",
                }
            });
        }
    });
}
//Sliders
function initSliders() {
    let sliders = document.querySelectorAll(".slider");

    //For each slider
    sliders.forEach(function (slider: any) {
        slider.sliderTiming = (slider.dataset.duration ? parseInt(slider.dataset.duration) * 1000 : 7000)
        let sliderImgs = slider.querySelectorAll(".slider__panels__item");
        let dotCont = slider.getElementsByClassName("slider__dots")[0];

        gsap.fromTo([slider.getElementsByClassName("slider__panels__item__inner"), slider.getElementsByClassName("slider__arrows"), slider.getElementsByClassName("slider__dots")], { opacity: 0 }, {
            opacity: 1,
            delay: 0,

            scrollTrigger: {
                trigger: slider,
                scrub: false,
                start: "top bottom-=5%",
            }
        });

        sliderImgs[0].classList.add("slider__panels__item--active");

        //If there is more than one image in this slider
        if (sliderImgs.length > 1) {
            slider.getElementsByClassName("slider__arrows__item--left")[0].classList.add("disable");

            slider.sliderInt = setTimeout(passiveFlip, slider.sliderTiming, slider, dotCont);

            //For each image add a dot to the nav
            for (let i = 0; i < sliderImgs.length; i++) {
                let dot = document.createElement("button");
                //Set first dot as active
                dot.className = (i === 0 ? "slider__dots__dot slider__dots__dot--active" : "slider__dots__dot");
                dot.name = "Slider slide select"
                dot.ariaLabel = "Slider slide select"

                dot.addEventListener("click", function () {
                    //Get index of clicked dot in dot container
                    let dotIndex = Array.prototype.indexOf.call(dotCont.children, this);

                    switchSlide(dotIndex, slider);
                });

                if (sliderImgs[i].dataset.year) {
                    let year = document.createElement("p")
                    year.innerText = sliderImgs[i].dataset.year
                    dot.appendChild(year);
                }

                dotCont.appendChild(dot);
            }

            //Arrow button listeners
            slider.getElementsByClassName("slider__arrows__item--right")[0].addEventListener("click", function (e) {
                let activeDot = slider.querySelector(".slider__dots__dot--active");
                let currIndex = Array.prototype.indexOf.call(dotCont.childNodes, activeDot);

                gsap.fromTo(e.target, { scale: .7, duration: .4 }, { scale: 1, duration: .4 });

                window.clearTimeout(slider.sliderInt);
                switchSlide(currIndex + 1, slider);
            });

            slider.getElementsByClassName("slider__arrows__item--left")[0].addEventListener("click", function (e) {
                let activeDot = slider.querySelector(".slider__dots__dot--active");
                let currIndex = Array.prototype.indexOf.call(dotCont.childNodes, activeDot);

                gsap.fromTo(e.target, { scale: .7, duration: .4 }, { scale: 1, duration: .4 });

                switchSlide(currIndex - 1, slider);
            });

        } else {
            dotCont.classList.add("slider__dots--hide");
            slider.getElementsByClassName("slider__arrows")[0].classList.add("slider__arrows--hide");
        }
    });
}

function switchSlide(index: number, slider: any) {
    let dotCont = slider.getElementsByClassName("slider__dots")[0];

    window.clearTimeout(slider.sliderInt);
    slider.sliderInt = setTimeout(passiveFlip, slider.sliderTiming, slider, dotCont);

    let currActive = slider.getElementsByClassName("slider__panels__item--active")[0];
    let activeVideo = currActive.querySelector("video.slider__panels__item__img");
    if (activeVideo) {
        setTimeout(() => {
            activeVideo.pause();
        }, 300);
    }

    //Image switch
    currActive.classList.remove("slider__panels__item--active");
    let newActive = slider.getElementsByClassName("slider__panels__item")[index];
    newActive.classList.add("slider__panels__item--active");

    let newActiveVideo = newActive.querySelector("video.slider__panels__item__img");
    if (newActiveVideo) {
        newActiveVideo.play();
    }

    //Dot switch
    slider.getElementsByClassName("slider__dots__dot--active")[0].classList.remove("slider__dots__dot--active");
    slider.getElementsByClassName("slider__dots__dot")[index].classList.add("slider__dots__dot--active");

    //If this is the first dot- make left arrow unclickable
    if (index === 0) {
        slider.getElementsByClassName("slider__arrows__item--left")[0].classList.add("disable");

    } else {
        slider.getElementsByClassName("slider__arrows__item--left")[0].classList.remove("disable");
    }

    //if this is the last dot- make right arrow unclickable
    if (index === (dotCont.children.length - 1)) {
        slider.getElementsByClassName("slider__arrows__item--right")[0].classList.add("disable");

    } else {
        slider.getElementsByClassName("slider__arrows__item--right")[0].classList.remove("disable");
    }
}

function passiveFlip(slider: any, dotCont: Element) {
    let activeDot = slider.querySelector(".slider__dots__dot--active");
    let currIndex = Array.prototype.indexOf.call(dotCont.childNodes, activeDot);

    if (currIndex === (dotCont.children.length - 1)) {
        currIndex = -1;
    }

    switchSlide((currIndex + 1), slider);
}
//Sliders end
jQuery(function ($){
    loader.load().then(() => {
        var markerBrandColor = "red";
        // try{
        //     var markerBrandColor = Drupal.settings.colors.mapMarkerColor;
        // }catch(e){

        // }
        try{
            INFWOverlay.prototype = new google.maps.OverlayView();
        }catch(err){
            console.log(err);

        }

        /**
         * @ custom infoview constructor
         */
        function INFWOverlay(content, map, marker, point, width, height, showed){

            // Now initialize all properties.
            this.width_ = width;
            this.height_ = height;
            this.point_ = point;
            this.content_ = content;
            this.marker_ = marker;
            this.map_ = map;
            this.initialShowed_ = showed;

            // Define a property to hold the image's div. We'll
            // actually create this div upon receipt of the onAdd()
            // method so we'll leave it null for now.
            this.div_ = null;

            // Explicitly call setMap on this overlay
            this.setMap(map);
        }

        // $(".node-retailer a[aria-controls=\"details\"]").on("shown.bs.tab", function (e){
        //     // we have to execute initialization for map layer that was hidden initially.
        //     var mapElement = $(".node-map");
        //     if(mapElement.length){
        //         var fnInit = "appmap_init_" + mapElement.data("id") + "()";
        //         try{
        //             eval(fnInit);
        //         }catch(e){
        //             console.log("Function " + fnInit + " has not been found!");
        //         }
        //     }
        // });

        // jquery plugin backstretch dependent code
        try{
            $(".view-retailer-hero .canvas").backstretch();
        }catch(err){

        }

        // Show map for details pane
        if(typeof google == "undefined" || !("maps" in google)){

            $(document).on("googleMapReady", function (){
                try{
                    mapPoint("map_retailer_canvas");
                }catch(e){
                    console.log("Google map API is unavailable.");
                }
            });
            console.log("map hook is defined");
        }else{
            mapPoint("map_retailer_canvas");
        }

        /**
         * Attach GOOGLE map to layer by DOM layerID
         */
        function mapPoint(mapID){

            if(document.getElementById(mapID) == null)return;

            var lat = jQuery("#" + mapID).attr("data-lat");
            var lon = jQuery("#" + mapID).attr("data-lng");
            var markerTitle = jQuery("#" + mapID).attr("data-title");
            var markerText = jQuery("#" + mapID).attr("data-text");
            var zoom = parseInt(jQuery("#" + mapID).attr("data-zoom"));
            var url = jQuery("#" + mapID).attr("data-url");
            var address = jQuery("#" + mapID).attr("data-address");
            var map = null;
            var marker = null;

            // Try to find place by given address
            if(address.length > 0){
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ "address": address }, function (results, status){
                    if(status === "OK"){
                        lat = results[0].geometry.location.lat();
                        lon = results[0].geometry.location.lng();
                    }else{
                        zoom = Drupal.settings.broadgateDefaultZoom;
                    }
                    mapReadyFinally();
                });
            }else{
                mapReadyFinally();
            }

            /**
             * Build map after all data is received
             */
            function mapReadyFinally(){
                var myPos = new google.maps.LatLng(lat, lon);
                var myOptions = {
                    zoom: zoom,
                    center: myPos,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: Drupal.settings.broadgateGStyles
                };
                var minimalWindowWidth = 600;
                var markerBrandColor = Drupal.settings.colors.mapMarkerColor;

                map = new google.maps.Map(document.getElementById(mapID), myOptions);

                marker = new google.maps.Marker({
                    position: myPos,
                    title: markerTitle,
                    icon: pinSymbol(markerBrandColor, "#FFF", ""),
                });

                var overlay = new INFWOverlay(markerText, map, marker, myPos, 200, 170, false);
                google.maps.event.addListener(marker, "click", function (){
                    var wd = jQuery(document).width();
                    if(wd >= minimalWindowWidth){
                        overlay.show();
                        marker.setMap(null);
                    }
                });

                marker.setMap(map);

                window.addEventListener("resize", function (e){
                    resizeCheck();
                }, true);

                function resizeCheck(){
                    var wd = jQuery(document).width();

                    if(wd < minimalWindowWidth){
                        overlay.hide();
                        marker.setMap(map);
                    }else{
                        overlay.show();
                        marker.setMap(null);
                    }

                }
            }
        }

        /**
         * onAdd is called when the map's panes are ready and the overlay has been
         * added to the map.
         */
        INFWOverlay.prototype.onAdd = function (){
            var CIW = this;

            var div = document.createElement("div");
            div.style.border = "none";
            div.style.borderWidth = "0px";
            div.style.position = "absolute";
            div.classList.add("customInfoWindow");

            // Create content of the div.
            div.innerHTML = CIW.content_;

            var divClose = document.createElement("div");
            divClose.classList.add("close");

            divClose.addEventListener("click", function (e){
                CIW.toggle();
                CIW.marker_.setMap(CIW.map_);
            });
            div.appendChild(divClose);

            CIW.div_ = div;

            if(!CIW.initialShowed_){
                this.hide();
            }

            // Add the element to the "overlayImage" pane.
            var panes = CIW.getPanes();
            panes.overlayImage.appendChild(CIW.div_);
        };

        INFWOverlay.prototype.draw = function (){

            // We use the south-west and north-east
            // coordinates of the overlay to peg it to the correct position and size.
            // To do this, we need to retrieve the projection from the overlay.
            var overlayProjection = this.getProjection();

            // Retrieve the south-west and north-east coordinates of this overlay
            // in LatLngs and convert them to pixel coordinates.
            // We'll use these coordinates to resize the div.
            var sw = overlayProjection.fromLatLngToDivPixel(this.point_);

            // Resize the image's div to fit the indicated dimensions.
            var div = this.div_;
            div.style.left = (sw.x - this.width_ - 5) + "px";
            div.style.top = (sw.y - 80) + "px";
            div.style.width = (this.width_) + "px";
            div.style.height = "auto";
        };

        INFWOverlay.prototype.onRemove = function (){
            this.div_.parentNode.removeChild(this.div_);
        };

        // Set the visibility to 'hidden' or 'visible'.
        INFWOverlay.prototype.hide = function (){
            if(this.div_){
                // The visibility property must be a string enclosed in quotes.
                this.div_.style.visibility = "hidden";
            }
        };

        INFWOverlay.prototype.show = function (){
            if(this.div_){
                this.div_.style.visibility = "visible";
            }
        };

        INFWOverlay.prototype.toggle = function (){
            if(this.div_){
                if(this.div_.style.visibility === "hidden"){
                    this.show();
                }else{
                    this.hide();
                }
            }
        };

        // Detach the map from the DOM via toggleDOM().
        // Note that if we later reattach the map, it will be visible again,
        // because the containing <div> is recreated in the overlay's onAdd() method.
        INFWOverlay.prototype.toggleDOM = function (){
            if(this.getMap()){
                // Note: setMap(null) calls OverlayView.onRemove()
                this.setMap(null);
            }else{
                this.setMap(this.map_);
            }
        };
    });
});
function initNewsslider(){
    const newssliders = document.querySelectorAll(".newsslider");

    newssliders.forEach(newsslider => {
        const imgs = newsslider.querySelectorAll(".newsslider__imgs__item");
        const subs = newsslider.querySelectorAll(".newsslider__sub__item");
        const main = newsslider.querySelector(".newsslider__main");

        let slideIndex = 0;
        flipSlider(imgs, subs, main, slideIndex);

        setInterval(() => {
            if(slideIndex === imgs.length - 1) slideIndex = 0;
            else slideIndex++;

            flipSlider(imgs, subs, main, slideIndex);
        }, 5000);
    });
}

function flipSlider(imgs, subs, main, slideIndex){
    const imgPrevClass = "newsslider__imgs__item--prev";
    const imgNextClass = "newsslider__imgs__item--next";

    const subPrevClass = "newsslider__sub__item--prev";
    const subNextClass = "newsslider__sub__item--next";

    for(let i = 0; i < imgs.length; i++){
        const img = imgs[i];
        const sub = subs[i];

        img.classList.remove(imgPrevClass, imgNextClass);
        sub.classList.remove(subPrevClass, subNextClass);

        if(i < slideIndex){
            img.classList.add(imgPrevClass);
            sub.classList.add(subPrevClass);

        }else if(i > slideIndex){
            img.classList.add(imgNextClass);
            sub.classList.add(subNextClass);
        }
    }

    main.href = subs[slideIndex].href;
}
import Swiper from"swiper";
import{ Pagination }from"swiper/modules";

function initFeaturedSlider(){
    new Swiper(".featured-static__inner", {
        spaceBetween: 10,
        slidesPerView: 1,
        modules: [Pagination],
        centeredSlides: true,
        pagination: {
            el: ".featured-static__inner__pagination",
            clickable: true
        }
    });

    const triggeredStatic = document.querySelector(".featured-static__inner--triggered");
    if(triggeredStatic){
        gsap.to(triggeredStatic, {
            opacity: 1,
            delay: 2,
            pointerEvents: "all"
        });
    }
}
import marquee from"vanilla-marquee";

function initMarquee(){
    const marquees = document.querySelectorAll<HTMLElement>(".marquee");

    marquees.forEach(marqueeEl => {
        const marqueeItemData = marqueeEl.dataset.items;
        let marqueeItemArr = marqueeItemData?.split(",").sort()

        const chunk = Math.ceil(marqueeItemArr.length / 3);
        marqueeItemArr = marqueeItemArr.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / chunk);

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [];
            }

            resultArray[chunkIndex].push(item);
            return resultArray;
        }, []);

        const row = marqueeEl.querySelector<HTMLElement>(".marquee__row");
        const blockMarquees = [row];
        for (let i = 0; i < marqueeItemArr.length; i++) {
            const clone = row.cloneNode(true) as HTMLElement;

            clone.innerHTML = marqueeItemArr[i].join("&nbsp;•&nbsp;") + "&nbsp;•&nbsp;";
            row.parentNode?.insertBefore(clone, row);

            blockMarquees.push(clone);
        }

        blockMarquees.forEach((marqueeEl, i) => {
            new marquee(marqueeEl,{
                direction: i === 2 ? "right" : "left",
                speed: (10 + (i * 5)),
                duplicated: true,
                gap: 0,
                startVisible: true
            });
        });
    });
}
import gsap from"gsap";

function initDualCta(){
    let dualCtas = document.querySelectorAll<HTMLElement>(".promo--2.promo--dual-cta");

    dualCtas.forEach(dualCta => {
        const items = dualCta.querySelectorAll(".promo__item__cont");

        items.forEach(item => {
            gsap.to(items, { duration: 0.3, width: 50 + "%" });

            item.addEventListener("mouseenter", () => {
                items.forEach(subItem => { 
                    if(subItem !== item){
                        gsap.to(subItem, { duration: 0.3, width: 47 + "%" });
                    }
                });
                gsap.to(item, { duration: 0.3, width: 53 + "%" });
            });

            item.addEventListener("mouseleave", () => {
                gsap.to(items, { duration: 0.3, width: 50 + "%" });
            });
        });
    });
}
import Swiper from"swiper";
import{ Navigation, Pagination }from"swiper/modules";

export default function initPanelSlider(){
    new Swiper(".panel-slider", {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className){
                let title = this.slides[index].getAttribute("data-title");
                return`<button class="${className}"><p>${title}</p></button>`;
            },
        },
        on: {
            slideChange: function (){
                let previousSlide = this.slides[this.previousIndex];
                let video = previousSlide.querySelector("video");
                if(video)video.pause();
            },

            init: function (swiper){
                const allVideos = swiper.el.querySelectorAll("video");
                allVideos.forEach(video => {
                    video.addEventListener("play", function (){
                        const videoOverlay = video.parentElement.querySelector<HTMLElement>(".swiper-slide__inner__overlay");
                        if(videoOverlay)videoOverlay.style.display = "none";
                    }, { once: true});
                });
            }
        },
        slidesPerView: 1,
        centeredSlides: true
    });
}

function initSparkleCursor(){
    if("ontouchstart" in document.documentElement)return;

    const main = document.querySelector(".main");
    if(!main)return;
    if(!(main.classList.contains("sparkle-cursor")))return;

    window.addEventListener("mousemove", function (e){
        var arr = [1, 0.8, 0.5, 0.2];

        arr.forEach(function (i){
            var x = (1 - i) * 100;
            var sparkle = document.createElement("div");

            sparkle.className = `sparkle sparkle--${i * 10}`;
            sparkle.style.top = e.clientY + Math.round(Math.random() * x - x / 2) + "px";
            sparkle.style.left = e.clientX + Math.round(Math.random() * x - x / 2) + "px";

            document.body.appendChild(sparkle);

            gsap.to(sparkle, {
                opacity: 0,
                duration: .01,
                delay: .2 + Math.round(Math.random() * (i * .4)),
                ease: "linear",
                onComplete: function (){
                    document.body.removeChild(sparkle);
                }
            });
        });
    }, false);
}